<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>下游气夹</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气夹</div>
          <div class="sensor2">进气夹</div>
          <div class="sensor-source">数据来源: 自动选择</div>
        </div>
        <!-- <div class="legend-station">
                <i class="iconfont iconshebei"></i>
                <span>除湿机</span>
              </div> -->
        <!-- <div class="legend-right">
                <div class="running">设备运行</div>
                <div class="stopped">设备停止</div>
                <div class="default">数据中断</div>
              </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">华坪</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">丽江</span>
        </div>

        <div class="cable-img">
          <el-tooltip class="station-block station-block-anchor-left" content="华坪下游锚室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationAnchorPlc/huaping"></router-link>
          </el-tooltip>
          <div class="stati anchor-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "华坪下游锚室",
                    humidityTooltipErrorAnchorHuapingDown,
                    humidityAllowedMaxAnchorHuapingDown,
                    runningAnchorHuapingDown,
                    malfunctionAnchorHuapingDown
                  )
                }}
              </div>
              <div :class="errorAnchorHuapingDown" class="state-info right-pos" @dblclick="hrefToStation('')">
                <p>{{ "华坪下游锚室(" + dataSourceAnchorHuapingDown + ")" }}</p>
                <p>
                  <span>{{ humidityAnchorHuapingDown | toFixed }}% {{ temperatureAnchorHuapingDown | toFixed }}°C</span>
                  <span :class="runningClassAnchorHuapingDown" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-anchor-right" content="丽江下游锚室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationAnchorPlc/Lijiang"></router-link>
          </el-tooltip>
          <div class="stati anchor-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "丽江下游锚室",
                    humidityTooltipErrorAnchorLijiangDown,
                    humidityAllowedMaxAnchorLijiangDown,
                    runningAnchorLijiangDown,
                    malfunctionAnchorLijiangDown
                  )
                }}
              </div>
              <div :class="errorAnchorLijiangDown" class="state-info left-pos" @dblclick="hrefToStation('')">
                <p>{{ "丽江下游锚室(" + dataSourceAnchorLijiangDown + ")" }}</p>
                <p>
                  <span>{{ humidityAnchorLijiangDown | toFixed }}% {{ temperatureAnchorLijiangDown | toFixed }}°C</span>
                  <span :class="runningClassAnchorLijiangDown" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-saddle-left" content="华坪下游鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationSaddlePlc/huaping"></router-link>
          </el-tooltip>
          <div class="stati saddle-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "华坪下游鞍室",
                    humidityTooltipErrorSaddleHuapingDown,
                    humidityAllowedMaxSaddleHuapingDown,
                    runningSaddleHuapingDown,
                    malfunctionSaddleHuapingDown
                  )
                }}
              </div>
              <div :class="errorSaddleHuapingDown" class="state-info bottom-right-pos" @dblclick="hrefToStation('')">
                <p>{{ "华坪下游鞍室(" + dataSourceSaddleHuapingDown + ")" }}</p>
                <p>
                  <span>{{ humiditySaddleHuapingDown | toFixed }}% {{ temperatureSaddleHuapingDown | toFixed }}°C</span>
                  <span :class="runningClassSaddleHuapingDown" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-saddle-right" content="丽江下游鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationSaddlePlc/Lijiang"></router-link>
          </el-tooltip>
          <div class="stati saddle-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "丽江下游鞍室",
                    humidityTooltipErrorSaddleLijiangDown,
                    humidityAllowedMaxSaddleLijiangDown,
                    runningSaddleLijiangDown,
                    malfunctionSaddleLijiangDown
                  )
                }}
              </div>
              <div :class="errorSaddleLijiangDown" class="state-info bottom-left-pos" @dblclick="hrefToStation('')">
                <p>{{ "丽江下游鞍室(" + dataSourceSaddleLijiangDown + ")" }}</p>
                <p>
                  <span>{{ humiditySaddleLijiangDown | toFixed }}% {{ temperatureSaddleLijiangDown | toFixed }}°C</span>
                  <span :class="runningClassSaddleLijiangDown" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCW2, humidityAllowedMaxCW2) }}
              </div>
              <div :class="errorCW2" class="state-info right-pos">
                <p>{{ "CW2传感器*(" + dataSourceCW2 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCW2 | toFixed }}% {{ temperatureCW2 | toFixed }}°C <br />
                    {{ pressureCW2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJW2, humidityAllowedMaxJW2) }}
              </div>
              <div :class="errorJW2" class="state-info top-right-pos">
                <p>{{ "JW2传感器*(" + dataSourceJW2 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityJW2 | toFixed }}% {{ temperatureJW2 | toFixed }}°C <br />
                    {{ pressureJW2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCW4, humidityAllowedMaxCW4) }}
              </div>
              <div :class="errorCW4" class="state-info right-pos">
                <p>{{ "CW4传感器*(" + dataSourceCW4 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCW4 | toFixed }}% {{ temperatureCW4 | toFixed }}°C <br />
                    {{ pressureCW4 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM2, humidityAllowedMaxCM2) }}
              </div>
              <div :class="errorCM2" class="state-info left-pos">
                <p>{{ "CM2传感器(" + dataSourceCM2 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCM2 | toFixed }}% {{ temperatureCM2 | toFixed }}°C <br />
                    {{ pressureCM2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM2, humidityAllowedMaxJM2) }}
              </div>
              <div :class="errorJM2" class="state-info top-right-pos">
                <p>{{ "JM2传感器*(" + dataSourceJM2 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityJM2 | toFixed }}% {{ temperatureJM2 | toFixed }}°C <br />
                    {{ pressureJM2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM4, humidityAllowedMaxCM4) }}
              </div>
              <div :class="errorCM4" class="state-info left-pos">
                <p>{{ "CM4传感器*(" + dataSourceCM4 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCM4 | toFixed }}% {{ temperatureCM4 | toFixed }}°C <br />
                    {{ pressureCM4 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM4, humidityAllowedMaxJM4) }}
              </div>
              <div :class="errorJM4" class="state-info top-right-pos-2">
                <p>{{ "JM4传感器(" + dataSourceJM4 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityJM4 | toFixed }}% {{ temperatureJM4 | toFixed }}°C <br />
                    {{ pressureJM4 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM6, humidityAllowedMaxCM6) }}
              </div>
              <div :class="errorCM6" class="state-info top-pos">
                <p>{{ "CM6传感器(" + dataSourceCM6 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCM6 | toFixed }}% {{ temperatureCM6 | toFixed }}°C <br />
                    {{ pressureCM6 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM6, humidityAllowedMaxJM6) }}
              </div>
              <div :class="errorJM6" class="state-info top-left-pos-2">
                <p>{{ "JM6传感器*(" + dataSourceJM6 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityJM6 | toFixed }}% {{ temperatureJM6 | toFixed }}°C <br />
                    {{ pressureJM6 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM8, humidityAllowedMaxCM8) }}
              </div>
              <div :class="errorCM8" class="state-info right-pos">
                <p>{{ "CM8传感器(" + dataSourceCM8 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCM8 | toFixed }}% {{ temperatureCM8 | toFixed }}°C <br />
                    {{ pressureCM8 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM8, humidityAllowedMaxJM8) }}
              </div>
              <div :class="errorJM8" class="state-info top-left-pos">
                <p>{{ "JM8传感器(" + dataSourceJM8 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityJM8 | toFixed }}% {{ temperatureJM8 | toFixed }}°C <br />
                    {{ pressureJM8 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM10, humidityAllowedMaxCM10) }}
              </div>
              <div :class="errorCM10" class="state-info right-pos">
                <p>{{ "CM10传感器(" + dataSourceCM10 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCM10 | toFixed }}% {{ temperatureCM10 | toFixed }}°C <br />
                    {{ pressureCM10 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCE4, humidityAllowedMaxCE4) }}
              </div>
              <div :class="errorCE4" class="state-info left-pos">
                <p>{{ "CE4传感器(" + dataSourceCE4 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCE4 | toFixed }}% {{ temperatureCE4 | toFixed }}°C <br />
                    {{ pressureCE4 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex14">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJE2, humidityAllowedMaxJE2) }}
              </div>
              <div :class="errorJE2" class="state-info top-left-pos">
                <p>{{ "JE2传感器(" + dataSourceJE2 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityJE2 | toFixed }}% {{ temperatureJE2 | toFixed }}°C <br />
                    {{ pressureJE2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex15">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCE2, humidityAllowedMaxCE2) }}
              </div>
              <div :class="errorCE2" class="state-info left-pos">
                <p>{{ "CE2传感器(" + dataSourceCE2 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCE2 | toFixed }}% {{ temperatureCE2 | toFixed }}°C <br />
                    {{ pressureCE2 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>上游气夹</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气夹</div>
          <div class="sensor2">进气夹</div>
          <div class="sensor-source">数据来源: 自动选择</div>
        </div>
        <!-- <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div> -->
        <!-- <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div> -->
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">华坪</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">丽江</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-anchor-left" content="华坪上游锚室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationAnchorPlc/huaping"></router-link>
          </el-tooltip>
          <div class="stati anchor-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "华坪上游锚室",
                    humidityTooltipErrorAnchorHuapingUp,
                    humidityAllowedMaxAnchorHuapingUp,
                    runningAnchorHuapingUp,
                    malfunctionAnchorHuapingUp
                  )
                }}
              </div>
              <div :class="errorAnchorHuapingUp" class="state-info right-pos" @dblclick="hrefToStation('')">
                <p>{{"华坪上游锚室(" + dataSourceAnchorHuapingUp + ")" }}</p>
                <p>
                  <span>{{ humidityAnchorHuapingUp | toFixed }}% {{ temperatureAnchorHuapingUp | toFixed }}°C</span>
                  <span :class="runningClassAnchorHuapingUp" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-anchor-right" content="丽江上游锚室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationAnchorPlc/Lijiang"></router-link>
          </el-tooltip>
          <div class="stati anchor-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "丽江上游锚室",
                    humidityTooltipErrorAnchorLijiangUp,
                    humidityAllowedMaxAnchorLijiangUp,
                    runningAnchorLijiangUp,
                    malfunctionAnchorLijiangUp
                  )
                }}
              </div>
              <div :class="errorAnchorLijiangUp" class="state-info left-pos" @dblclick="hrefToStation('')">
                <p>{{"丽江上游锚室(" + dataSourceAnchorLijiangUp + ")" }}</p>
                <p>
                  <span>{{ humidityAnchorLijiangUp | toFixed }}% {{ temperatureAnchorLijiangUp | toFixed }}°C</span>
                  <span :class="runningClassAnchorLijiangUp" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-saddle-left" content="华坪上游鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationSaddlePlc/huaping"></router-link>
          </el-tooltip>
          <div class="stati saddle-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "华坪上游鞍室",
                    humidityTooltipErrorSaddleHuapingUp,
                    humidityAllowedMaxSaddleHuapingUp,
                    runningSaddleHuapingUp,
                    malfunctionSaddleHuapingUp
                  )
                }}
              </div>
              <div :class="errorSaddleHuapingUp" class="state-info bottom-right-pos" @dblclick="hrefToStation('')">
                <p>{{"华坪上游鞍室(" + dataSourceSaddleHuapingUp + ")" }}</p>
                <p>
                  <span>{{ humiditySaddleHuapingUp | toFixed }}% {{ temperatureSaddleHuapingUp | toFixed }}°C</span>
                  <span :class="runningClassSaddleHuapingUp" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-saddle-right" content="丽江上游鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jinshajiang/stationSaddlePlc/Lijiang"></router-link>
          </el-tooltip>
          <div class="stati saddle-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "丽江上游鞍室",
                    humidityTooltipErrorSaddleLijiangUp,
                    humidityAllowedMaxSaddleLijiangUp,
                    runningSaddleLijiangUp,
                    malfunctionSaddleLijiangUp
                  )
                }}
              </div>
              <div :class="errorSaddleLijiangUp" class="state-info bottom-left-pos" @dblclick="hrefToStation('')">
                <p>{{"丽江上游鞍室(" + dataSourceSaddleLijiangUp + ")" }}</p>
                <p>
                  <span>{{ humiditySaddleLijiangUp | toFixed }}% {{ temperatureSaddleLijiangUp | toFixed }}°C</span>
                  <span :class="runningClassSaddleLijiangUp" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCW1, humidityAllowedMaxCW1) }}
              </div>
              <div :class="errorCW1" class="state-info right-pos">
                <p>{{ "CW1传感器*(" + dataSourceCW1 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCW1 | toFixed }}% {{ temperatureCW1 | toFixed }}°C <br />
                    {{ pressureCW1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJW1, humidityAllowedMaxJW1) }}
              </div>
              <div :class="errorJW1" class="state-info top-right-pos">
                <p>{{ "JW1传感器(" + dataSourceJW1 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityJW1 | toFixed }}% {{ temperatureJW1 | toFixed }}°C <br />
                    {{ pressureJW1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCW3, humidityAllowedMaxCW3) }}
              </div>
              <div :class="errorCW3" class="state-info right-pos">
                <p>{{ "CW3传感器(" + dataSourceCW3 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCW3 | toFixed }}% {{ temperatureCW3 | toFixed }}°C <br />
                    {{ pressureCW3 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM1, humidityAllowedMaxCM1) }}
              </div>
              <div :class="errorCM1" class="state-info left-pos">
                <p>{{ "CM1传感器(" + dataSourceCM1 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCM1 | toFixed }}% {{ temperatureCM1 | toFixed }}°C <br />
                    {{ pressureCM1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM1, humidityAllowedMaxJM1) }}
              </div>
              <div :class="errorJM1" class="state-info top-right-pos">
                <p>{{ "JM1传感器(" + dataSourceJM1 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityJM1 | toFixed }}% {{ temperatureJM1 | toFixed }}°C <br />
                    {{ pressureJM1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM3, humidityAllowedMaxCM3) }}
              </div>
              <div :class="errorCM3" class="state-info left-pos">
                <p>{{ "CM3传感器(" + dataSourceCM3 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCM3 | toFixed }}% {{ temperatureCM3 | toFixed }}°C <br />
                    {{ pressureCM3 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM3, humidityAllowedMaxJM3) }}
              </div>
              <div :class="errorJM3" class="state-info top-right-pos-2">
                <p>{{ "JM3传感器(" + dataSourceJM3 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityJM3 | toFixed }}% {{ temperatureJM3 | toFixed }}°C <br />
                    {{ pressureJM3 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM5, humidityAllowedMaxCM5) }}
              </div>
              <div :class="errorCM5" class="state-info top-pos">
                <p>{{ "CM5传感器(" + dataSourceCM5 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCM5 | toFixed }}% {{ temperatureCM5 | toFixed }}°C <br />
                    {{ pressureCM5 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM5, humidityAllowedMaxJM5) }}
              </div>
              <div :class="errorJM5" class="state-info top-left-pos-2">
                <p>{{ "JM5传感器(" + dataSourceJM5 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityJM5 | toFixed }}% {{ temperatureJM5 | toFixed }}°C <br />
                    {{ pressureJM5 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM7, humidityAllowedMaxCM7) }}
              </div>
              <div :class="errorCM7" class="state-info right-pos">
                <p>{{ "CM7传感器(" + dataSourceCM7 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCM7 | toFixed }}% {{ temperatureCM7 | toFixed }}°C <br />
                    {{ pressureCM7 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJM7, humidityAllowedMaxJM7) }}
              </div>
              <div :class="errorJM7" class="state-info top-left-pos">
                <p>{{ "JM7传感器(" + dataSourceJM7 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityJM7 | toFixed }}% {{ temperatureJM7 | toFixed }}°C <br />
                    {{ pressureJM7 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCM9, humidityAllowedMaxCM9) }}
              </div>
              <div :class="errorCM9" class="state-info right-pos">
                <p>{{ "CM9传感器(" + dataSourceCM9 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCM9 | toFixed }}% {{ temperatureCM9 | toFixed }}°C <br />
                    {{ pressureCM9 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCE3, humidityAllowedMaxCE3) }}
              </div>
              <div :class="errorCE3" class="state-info left-pos">
                <p>{{ "CE3传感器(" + dataSourceCE3 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCE3 | toFixed }}% {{ temperatureCE3 | toFixed }}°C <br />
                    {{ pressureCE3 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor2 ex14">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorJE1, humidityAllowedMaxJE1) }}
              </div>
              <div :class="errorJE1" class="state-info top-left-pos">
                <p>{{ "JE1传感器(" + dataSourceJE1 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityJE1 | toFixed }}% {{ temperatureJE1 | toFixed }}°C <br />
                    {{ pressureJE1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 ex15">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorCE1, humidityAllowedMaxCE1) }}
              </div>
              <div :class="errorCE1" class="state-info left-pos">
                <p>{{ "CE1传感器(" + dataSourceCE1 + ")" }}</p>
                <p>
                  <span
                    >{{ humidityCE1 | toFixed }}% {{ temperatureCE1 | toFixed }}°C <br />
                    {{ pressureCE1 | toFixed }}Pa</span
                  >
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      //data source
      dataSourceCW2: "--",
      dataSourceJW2: "--",
      dataSourceCW4: "--",
      dataSourceCM2: "--",
      dataSourceJM2: "--",
      dataSourceCM4: "--",
      dataSourceJM4: "--",
      dataSourceCM6: "--",
      dataSourceJM6: "--",
      dataSourceCM8: "--",
      dataSourceJM8: "--",
      dataSourceCM10: "--",
      dataSourceCE4: "--",
      dataSourceJE2: "--",
      dataSourceCE2: "--",
      dataSourceCW1: "--",
      dataSourceJW1: "--",
      dataSourceCW3: "--",
      dataSourceCM1: "--",
      dataSourceJM1: "--",
      dataSourceCM3: "--",
      dataSourceJM3: "--",
      dataSourceCM5: "--",
      dataSourceJM5: "--",
      dataSourceCM7: "--",
      dataSourceJM7: "--",
      dataSourceCM9: "--",
      dataSourceCE3: "--",
      dataSourceJE1: "--",
      dataSourceCE1: "--",

      dataSourceAnchorHuapingUp: "--",
      dataSourceAnchorHuapingDown: "--",
      dataSourceAnchorLijiangUp: "--",
      dataSourceAnchorLijiangDown: "--",
      dataSourceSaddleHuapingUp: "--",
      dataSourceSaddleHuapingDown: "--",
      dataSourceSaddleLijiangUp: "--",
      dataSourceSaddleLijiangDown: "--",

      //humidity, temperature
      humidityCW2: "--",
      humidityJW2: "--",
      humidityCW4: "--",
      humidityCM2: "--",
      humidityJM2: "--",
      humidityCM4: "--",
      humidityJM4: "--",
      humidityCM6: "--",
      humidityJM6: "--",
      humidityCM8: "--",
      humidityJM8: "--",
      humidityCM10: "--",
      humidityCE4: "--",
      humidityJE2: "--",
      humidityCE2: "--",
      humidityCW1: "--",
      humidityJW1: "--",
      humidityCW3: "--",
      humidityCM1: "--",
      humidityJM1: "--",
      humidityCM3: "--",
      humidityJM3: "--",
      humidityCM5: "--",
      humidityJM5: "--",
      humidityCM7: "--",
      humidityJM7: "--",
      humidityCM9: "--",
      humidityCE3: "--",
      humidityJE1: "--",
      humidityCE1: "--",

      humiditySensorCW2: "--",
      humiditySensorJW2: "--",
      humiditySensorCW4: "--",
      humiditySensorCM2: "--",
      humiditySensorJM2: "--",
      humiditySensorCM4: "--",
      humiditySensorJM4: "--",
      humiditySensorCM6: "--",
      humiditySensorJM6: "--",
      humiditySensorCM8: "--",
      humiditySensorJM8: "--",
      humiditySensorCM10: "--",
      humiditySensorCE4: "--",
      humiditySensorJE2: "--",
      humiditySensorCE2: "--",
      humiditySensorCW1: "--",
      humiditySensorJW1: "--",
      humiditySensorCW3: "--",
      humiditySensorCM1: "--",
      humiditySensorJM1: "--",
      humiditySensorCM3: "--",
      humiditySensorJM3: "--",
      humiditySensorCM5: "--",
      humiditySensorJM5: "--",
      humiditySensorCM7: "--",
      humiditySensorJM7: "--",
      humiditySensorCM9: "--",
      humiditySensorCE3: "--",
      humiditySensorJE1: "--",
      humiditySensorCE1: "--",

      humidityPlcCW2: "--",
      humidityPlcJW2: "--",
      humidityPlcCW4: "--",
      humidityPlcCM2: "--",
      humidityPlcJM2: "--",
      humidityPlcCM4: "--",
      humidityPlcJM4: "--",
      humidityPlcCM6: "--",
      humidityPlcJM6: "--",
      humidityPlcCM8: "--",
      humidityPlcJM8: "--",
      humidityPlcCM10: "--",
      humidityPlcCE4: "--",
      humidityPlcJE2: "--",
      humidityPlcCE2: "--",
      humidityPlcCW1: "--",
      humidityPlcJW1: "--",
      humidityPlcCW3: "--",
      humidityPlcCM1: "--",
      humidityPlcJM1: "--",
      humidityPlcCM3: "--",
      humidityPlcJM3: "--",
      humidityPlcCM5: "--",
      humidityPlcJM5: "--",
      humidityPlcCM7: "--",
      humidityPlcJM7: "--",
      humidityPlcCM9: "--",
      humidityPlcCE3: "--",
      humidityPlcJE1: "--",
      humidityPlcCE1: "--",

      humidityWinccCW2: "--",
      humidityWinccJW2: "--",
      humidityWinccCW4: "--",
      humidityWinccCM2: "--",
      humidityWinccJM2: "--",
      humidityWinccCM4: "--",
      humidityWinccJM4: "--",
      humidityWinccCM6: "--",
      humidityWinccJM6: "--",
      humidityWinccCM8: "--",
      humidityWinccJM8: "--",
      humidityWinccCM10: "--",
      humidityWinccCE4: "--",
      humidityWinccJE2: "--",
      humidityWinccCE2: "--",
      humidityWinccCW1: "--",
      humidityWinccJW1: "--",
      humidityWinccCW3: "--",
      humidityWinccCM1: "--",
      humidityWinccJM1: "--",
      humidityWinccCM3: "--",
      humidityWinccJM3: "--",
      humidityWinccCM5: "--",
      humidityWinccJM5: "--",
      humidityWinccCM7: "--",
      humidityWinccJM7: "--",
      humidityWinccCM9: "--",
      humidityWinccCE3: "--",
      humidityWinccJE1: "--",
      humidityWinccCE1: "--",

      humidityAnchorHuapingUp: "--",
      humidityAnchorHuapingDown: "--",
      humidityAnchorLijiangUp: "--",
      humidityAnchorLijiangDown: "--",
      humiditySaddleHuapingUp: "--",
      humiditySaddleHuapingDown: "--",
      humiditySaddleLijiangUp: "--",
      humiditySaddleLijiangDown: "--",

      humidityPlcAnchorHuapingUp: "--",
      humidityPlcAnchorHuapingDown: "--",
      humidityPlcAnchorLijiangUp: "--",
      humidityPlcAnchorLijiangDown: "--",
      humidityPlcSaddleHuapingUp: "--",
      humidityPlcSaddleHuapingDown: "--",
      humidityPlcSaddleLijiangUp: "--",
      humidityPlcSaddleLijiangDown: "--",

      humidityWinccAnchorHuapingUp: "--",
      humidityWinccAnchorHuapingDown: "--",
      humidityWinccAnchorLijiangUp: "--",
      humidityWinccAnchorLijiangDown: "--",
      humidityWinccSaddleHuapingUp: "--",
      humidityWinccSaddleHuapingDown: "--",
      humidityWinccSaddleLijiangUp: "--",
      humidityWinccSaddleLijiangDown: "--",

      temperatureCW2: "--",
      temperatureJW2: "--",
      temperatureCW4: "--",
      temperatureCM2: "--",
      temperatureJM2: "--",
      temperatureCM4: "--",
      temperatureJM4: "--",
      temperatureCM6: "--",
      temperatureJM6: "--",
      temperatureCM8: "--",
      temperatureJM8: "--",
      temperatureCM10: "--",
      temperatureCE4: "--",
      temperatureJE2: "--",
      temperatureCE2: "--",
      temperatureCW1: "--",
      temperatureJW1: "--",
      temperatureCW3: "--",
      temperatureCM1: "--",
      temperatureJM1: "--",
      temperatureCM3: "--",
      temperatureJM3: "--",
      temperatureCM5: "--",
      temperatureJM5: "--",
      temperatureCM7: "--",
      temperatureJM7: "--",
      temperatureCM9: "--",
      temperatureCE3: "--",
      temperatureJE1: "--",
      temperatureCE1: "--",

      temperatureSensorCW2: "--",
      temperatureSensorJW2: "--",
      temperatureSensorCW4: "--",
      temperatureSensorCM2: "--",
      temperatureSensorJM2: "--",
      temperatureSensorCM4: "--",
      temperatureSensorJM4: "--",
      temperatureSensorCM6: "--",
      temperatureSensorJM6: "--",
      temperatureSensorCM8: "--",
      temperatureSensorJM8: "--",
      temperatureSensorCM10: "--",
      temperatureSensorCE4: "--",
      temperatureSensorJE2: "--",
      temperatureSensorCE2: "--",
      temperatureSensorCW1: "--",
      temperatureSensorJW1: "--",
      temperatureSensorCW3: "--",
      temperatureSensorCM1: "--",
      temperatureSensorJM1: "--",
      temperatureSensorCM3: "--",
      temperatureSensorJM3: "--",
      temperatureSensorCM5: "--",
      temperatureSensorJM5: "--",
      temperatureSensorCM7: "--",
      temperatureSensorJM7: "--",
      temperatureSensorCM9: "--",
      temperatureSensorCE3: "--",
      temperatureSensorJE1: "--",
      temperatureSensorCE1: "--",

      temperaturePlcCW2: "--",
      temperaturePlcJW2: "--",
      temperaturePlcCW4: "--",
      temperaturePlcCM2: "--",
      temperaturePlcJM2: "--",
      temperaturePlcCM4: "--",
      temperaturePlcJM4: "--",
      temperaturePlcCM6: "--",
      temperaturePlcJM6: "--",
      temperaturePlcCM8: "--",
      temperaturePlcJM8: "--",
      temperaturePlcCM10: "--",
      temperaturePlcCE4: "--",
      temperaturePlcJE2: "--",
      temperaturePlcCE2: "--",
      temperaturePlcCW1: "--",
      temperaturePlcJW1: "--",
      temperaturePlcCW3: "--",
      temperaturePlcCM1: "--",
      temperaturePlcJM1: "--",
      temperaturePlcCM3: "--",
      temperaturePlcJM3: "--",
      temperaturePlcCM5: "--",
      temperaturePlcJM5: "--",
      temperaturePlcCM7: "--",
      temperaturePlcJM7: "--",
      temperaturePlcCM9: "--",
      temperaturePlcCE3: "--",
      temperaturePlcJE1: "--",
      temperaturePlcCE1: "--",

      temperatureWinccCW2: "--",
      temperatureWinccJW2: "--",
      temperatureWinccCW4: "--",
      temperatureWinccCM2: "--",
      temperatureWinccJM2: "--",
      temperatureWinccCM4: "--",
      temperatureWinccJM4: "--",
      temperatureWinccCM6: "--",
      temperatureWinccJM6: "--",
      temperatureWinccCM8: "--",
      temperatureWinccJM8: "--",
      temperatureWinccCM10: "--",
      temperatureWinccCE4: "--",
      temperatureWinccJE2: "--",
      temperatureWinccCE2: "--",
      temperatureWinccCW1: "--",
      temperatureWinccJW1: "--",
      temperatureWinccCW3: "--",
      temperatureWinccCM1: "--",
      temperatureWinccJM1: "--",
      temperatureWinccCM3: "--",
      temperatureWinccJM3: "--",
      temperatureWinccCM5: "--",
      temperatureWinccJM5: "--",
      temperatureWinccCM7: "--",
      temperatureWinccJM7: "--",
      temperatureWinccCM9: "--",
      temperatureWinccCE3: "--",
      temperatureWinccJE1: "--",
      temperatureWinccCE1: "--",

      temperatureAnchorHuapingUp: "--",
      temperatureAnchorHuapingDown: "--",
      temperatureAnchorLijiangUp: "--",
      temperatureAnchorLijiangDown: "--",
      temperatureSaddleHuapingUp: "--",
      temperatureSaddleHuapingDown: "--",
      temperatureSaddleLijiangUp: "--",
      temperatureSaddleLijiangDown: "--",

      temperaturePlcAnchorHuapingUp: "--",
      temperaturePlcAnchorHuapingDown: "--",
      temperaturePlcAnchorLijiangUp: "--",
      temperaturePlcAnchorLijiangDown: "--",
      temperaturePlcSaddleHuapingUp: "--",
      temperaturePlcSaddleHuapingDown: "--",
      temperaturePlcSaddleLijiangUp: "--",
      temperaturePlcSaddleLijiangDown: "--",

      temperatureWinccAnchorHuapingUp: "--",
      temperatureWinccAnchorHuapingDown: "--",
      temperatureWinccAnchorLijiangUp: "--",
      temperatureWinccAnchorLijiangDown: "--",
      temperatureWinccSaddleHuapingUp: "--",
      temperatureWinccSaddleHuapingDown: "--",
      temperatureWinccSaddleLijiangUp: "--",
      temperatureWinccSaddleLijiangDown: "--",

      pressureCW2: "--",
      pressureJW2: "--",
      pressureCW4: "--",
      pressureCM2: "--",
      pressureJM2: "--",
      pressureCM4: "--",
      pressureJM4: "--",
      pressureCM6: "--",
      pressureJM6: "--",
      pressureCM8: "--",
      pressureJM8: "--",
      pressureCM10: "--",
      pressureCE4: "--",
      pressureJE2: "--",
      pressureCE2: "--",
      pressureCW1: "--",
      pressureJW1: "--",
      pressureCW3: "--",
      pressureCM1: "--",
      pressureJM1: "--",
      pressureCM3: "--",
      pressureJM3: "--",
      pressureCM5: "--",
      pressureJM5: "--",
      pressureCM7: "--",
      pressureJM7: "--",
      pressureCM9: "--",
      pressureCE3: "--",
      pressureJE1: "--",
      pressureCE1: "--",

      pressureSensorCW2: "--",
      pressureSensorJW2: "--",
      pressureSensorCW4: "--",
      pressureSensorCM2: "--",
      pressureSensorJM2: "--",
      pressureSensorCM4: "--",
      pressureSensorJM4: "--",
      pressureSensorCM6: "--",
      pressureSensorJM6: "--",
      pressureSensorCM8: "--",
      pressureSensorJM8: "--",
      pressureSensorCM10: "--",
      pressureSensorCE4: "--",
      pressureSensorJE2: "--",
      pressureSensorCE2: "--",
      pressureSensorCW1: "--",
      pressureSensorJW1: "--",
      pressureSensorCW3: "--",
      pressureSensorCM1: "--",
      pressureSensorJM1: "--",
      pressureSensorCM3: "--",
      pressureSensorJM3: "--",
      pressureSensorCM5: "--",
      pressureSensorJM5: "--",
      pressureSensorCM7: "--",
      pressureSensorJM7: "--",
      pressureSensorCM9: "--",
      pressureSensorCE3: "--",
      pressureSensorJE1: "--",
      pressureSensorCE1: "--",

      pressurePlcCW2: "--",
      pressurePlcJW2: "--",
      pressurePlcCW4: "--",
      pressurePlcCM2: "--",
      pressurePlcJM2: "--",
      pressurePlcCM4: "--",
      pressurePlcJM4: "--",
      pressurePlcCM6: "--",
      pressurePlcJM6: "--",
      pressurePlcCM8: "--",
      pressurePlcJM8: "--",
      pressurePlcCM10: "--",
      pressurePlcCE4: "--",
      pressurePlcJE2: "--",
      pressurePlcCE2: "--",
      pressurePlcCW1: "--",
      pressurePlcJW1: "--",
      pressurePlcCW3: "--",
      pressurePlcCM1: "--",
      pressurePlcJM1: "--",
      pressurePlcCM3: "--",
      pressurePlcJM3: "--",
      pressurePlcCM5: "--",
      pressurePlcJM5: "--",
      pressurePlcCM7: "--",
      pressurePlcJM7: "--",
      pressurePlcCM9: "--",
      pressurePlcCE3: "--",
      pressurePlcJE1: "--",
      pressurePlcCE1: "--",

      pressureWinccPlcCW2: "--",
      pressureWinccPlcJW2: "--",
      pressureWinccPlcCW4: "--",
      pressureWinccPlcCM2: "--",
      pressureWinccPlcJM2: "--",
      pressureWinccPlcCM4: "--",
      pressureWinccPlcJM4: "--",
      pressureWinccPlcCM6: "--",
      pressureWinccPlcJM6: "--",
      pressureWinccPlcCM8: "--",
      pressureWinccPlcJM8: "--",
      pressureWinccPlcCM10: "--",
      pressureWinccPlcCE4: "--",
      pressureWinccPlcJE2: "--",
      pressureWinccPlcCE2: "--",
      pressureWinccPlcCW1: "--",
      pressureWinccPlcJW1: "--",
      pressureWinccPlcCW3: "--",
      pressureWinccPlcCM1: "--",
      pressureWinccPlcJM1: "--",
      pressureWinccPlcCM3: "--",
      pressureWinccPlcJM3: "--",
      pressureWinccPlcCM5: "--",
      pressureWinccPlcJM5: "--",
      pressureWinccPlcCM7: "--",
      pressureWinccPlcJM7: "--",
      pressureWinccPlcCM9: "--",
      pressureWinccPlcCE3: "--",
      pressureWinccPlcJE1: "--",
      pressureWinccPlcCE1: "--",

      //running
      runningAnchorHuapingUp: "--",
      runningAnchorHuapingDown: "--",
      runningAnchorLijiangUp: "--",
      runningAnchorLijiangDown: "--",
      runningSaddleHuapingUp: "--",
      runningSaddleHuapingDown: "--",
      runningSaddleLijiangUp: "--",
      runningSaddleLijiangDown: "--",

      runningPlcAnchorHuapingUp: "--",
      runningPlcAnchorHuapingDown: "--",
      runningPlcAnchorLijiangUp: "--",
      runningPlcAnchorLijiangDown: "--",
      runningPlcSaddleHuapingUp: "--",
      runningPlcSaddleHuapingDown: "--",
      runningPlcSaddleLijiangUp: "--",
      runningPlcSaddleLijiangDown: "--",

      runningWinccAnchorHuapingUp: "--",
      runningWinccAnchorHuapingDown: "--",
      runningWinccAnchorLijiangUp: "--",
      runningWinccAnchorLijiangDown: "--",
      runningWinccSaddleHuapingUp: "--",
      runningWinccSaddleHuapingDown: "--",
      runningWinccSaddleLijiangUp: "--",
      runningWinccSaddleLijiangDown: "--",

      //malfunction
      malfunctionAnchorHuapingUp: "--",
      malfunctionAnchorHuapingDown: "--",
      malfunctionAnchorLijiangUp: "--",
      malfunctionAnchorLijiangDown: "--",
      malfunctionSaddleHuapingUp: "--",
      malfunctionSaddleHuapingDown: "--",
      malfunctionSaddleLijiangUp: "--",
      malfunctionSaddleLijiangDown: "--",

      malfunctionPlcAnchorHuapingUp: "--",
      malfunctionPlcAnchorHuapingDown: "--",
      malfunctionPlcAnchorLijiangUp: "--",
      malfunctionPlcAnchorLijiangDown: "--",
      malfunctionPlcSaddleHuapingUp: "--",
      malfunctionPlcSaddleHuapingDown: "--",
      malfunctionPlcSaddleLijiangUp: "--",
      malfunctionPlcSaddleLijiangDown: "--",

      malfunctionWinccAnchorHuapingUp: "--",
      malfunctionWinccAnchorHuapingDown: "--",
      malfunctionWinccAnchorLijiangUp: "--",
      malfunctionWinccAnchorLijiangDown: "--",
      malfunctionWinccSaddleHuapingUp: "--",
      malfunctionWinccSaddleHuapingDown: "--",
      malfunctionWinccSaddleLijiangUp: "--",
      malfunctionWinccSaddleLijiangDown: "--",

      //error
      errorCW2: "--",
      errorJW2: "--",
      errorCW4: "--",
      errorCM2: "--",
      errorJM2: "--",
      errorCM4: "--",
      errorJM4: "--",
      errorCM6: "--",
      errorJM6: "--",
      errorCM8: "--",
      errorJM8: "--",
      errorCM10: "--",
      errorCE4: "--",
      errorJE2: "--",
      errorCE2: "--",
      errorCW1: "--",
      errorJW1: "--",
      errorCW3: "--",
      errorCM1: "--",
      errorJM1: "--",
      errorCM3: "--",
      errorJM3: "--",
      errorCM5: "--",
      errorJM5: "--",
      errorCM7: "--",
      errorJM7: "--",
      errorCM9: "--",
      errorCE3: "--",
      errorJE1: "--",
      errorCE1: "--",

      errorSensorCW2: "--",
      errorSensorJW2: "--",
      errorSensorCW4: "--",
      errorSensorCM2: "--",
      errorSensorJM2: "--",
      errorSensorCM4: "--",
      errorSensorJM4: "--",
      errorSensorCM6: "--",
      errorSensorJM6: "--",
      errorSensorCM8: "--",
      errorSensorJM8: "--",
      errorSensorCM10: "--",
      errorSensorCE4: "--",
      errorSensorJE2: "--",
      errorSensorCE2: "--",
      errorSensorCW1: "--",
      errorSensorJW1: "--",
      errorSensorCW3: "--",
      errorSensorCM1: "--",
      errorSensorJM1: "--",
      errorSensorCM3: "--",
      errorSensorJM3: "--",
      errorSensorCM5: "--",
      errorSensorJM5: "--",
      errorSensorCM7: "--",
      errorSensorJM7: "--",
      errorSensorCM9: "--",
      errorSensorCE3: "--",
      errorSensorJE1: "--",
      errorSensorCE1: "--",

      errorPlcCW2: "--",
      errorPlcJW2: "--",
      errorPlcCW4: "--",
      errorPlcCM2: "--",
      errorPlcJM2: "--",
      errorPlcCM4: "--",
      errorPlcJM4: "--",
      errorPlcCM6: "--",
      errorPlcJM6: "--",
      errorPlcCM8: "--",
      errorPlcJM8: "--",
      errorPlcCM10: "--",
      errorPlcCE4: "--",
      errorPlcJE2: "--",
      errorPlcCE2: "--",
      errorPlcCW1: "--",
      errorPlcJW1: "--",
      errorPlcCW3: "--",
      errorPlcCM1: "--",
      errorPlcJM1: "--",
      errorPlcCM3: "--",
      errorPlcJM3: "--",
      errorPlcCM5: "--",
      errorPlcJM5: "--",
      errorPlcCM7: "--",
      errorPlcJM7: "--",
      errorPlcCM9: "--",
      errorPlcCE3: "--",
      errorPlcJE1: "--",
      errorPlcCE1: "--",

      errorWinccCW2: "--",
      errorWinccJW2: "--",
      errorWinccCW4: "--",
      errorWinccCM2: "--",
      errorWinccJM2: "--",
      errorWinccCM4: "--",
      errorWinccJM4: "--",
      errorWinccCM6: "--",
      errorWinccJM6: "--",
      errorWinccCM8: "--",
      errorWinccJM8: "--",
      errorWinccCM10: "--",
      errorWinccCE4: "--",
      errorWinccJE2: "--",
      errorWinccCE2: "--",
      errorWinccCW1: "--",
      errorWinccJW1: "--",
      errorWinccCW3: "--",
      errorWinccCM1: "--",
      errorWinccJM1: "--",
      errorWinccCM3: "--",
      errorWinccJM3: "--",
      errorWinccCM5: "--",
      errorWinccJM5: "--",
      errorWinccCM7: "--",
      errorWinccJM7: "--",
      errorWinccCM9: "--",
      errorWinccCE3: "--",
      errorWinccJE1: "--",
      errorWinccCE1: "--",

      errorSaddleLijiangUp: "--",
      errorSaddleLijiangDown: "--",
      errorSaddleHuapingUp: "--",
      errorSaddleHuapingDown: "--",
      errorAnchorLijiangUp: "--",
      errorAnchorLijiangDown: "--",
      errorAnchorHuapingUp: "--",
      errorAnchorHuapingDown: "--",

      errorPlcSaddleLijiangUp: "--",
      errorPlcSaddleLijiangDown: "--",
      errorPlcSaddleHuapingUp: "--",
      errorPlcSaddleHuapingDown: "--",
      errorPlcAnchorLijiangUp: "--",
      errorPlcAnchorLijiangDown: "--",
      errorPlcAnchorHuapingUp: "--",
      errorPlcAnchorHuapingDown: "--",

      errorWinccSaddleLijiangUp: "--",
      errorWinccSaddleLijiangDown: "--",
      errorWinccSaddleHuapingUp: "--",
      errorWinccSaddleHuapingDown: "--",
      errorWinccAnchorLijiangUp: "--",
      errorWinccAnchorLijiangDown: "--",
      errorWinccAnchorHuapingUp: "--",
      errorWinccAnchorHuapingDown: "--",

      //running class
      runningClassAnchorHuapingUp: "--",
      runningClassAnchorHuapingDown: "--",
      runningClassAnchorLijiangUp: "--",
      runningClassAnchorLijiangDown: "--",
      runningClassSaddleHuapingUp: "--",
      runningClassSaddleHuapingDown: "--",
      runningClassSaddleLijiangUp: "--",
      runningClassSaddleLijiangDown: "--",

      runningClassPlcAnchorHuapingUp: "--",
      runningClassPlcAnchorHuapingDown: "--",
      runningClassPlcAnchorLijiangUp: "--",
      runningClassPlcAnchorLijiangDown: "--",
      runningClassPlcSaddleHuapingUp: "--",
      runningClassPlcSaddleHuapingDown: "--",
      runningClassPlcSaddleLijiangUp: "--",
      runningClassPlcSaddleLijiangDown: "--",

      runningClassWinccAnchorHuapingUp: "--",
      runningClassWinccAnchorHuapingDown: "--",
      runningClassWinccAnchorLijiangUp: "--",
      runningClassWinccAnchorLijiangDown: "--",
      runningClassWinccSaddleHuapingUp: "--",
      runningClassWinccSaddleHuapingDown: "--",
      runningClassWinccSaddleLijiangUp: "--",
      runningClassWinccSaddleLijiangDown: "--",

      //humidity allowed max
      humidityAllowedMaxCW2: "--",
      humidityAllowedMaxJW2: "--",
      humidityAllowedMaxCW4: "--",
      humidityAllowedMaxCM2: "--",
      humidityAllowedMaxJM2: "--",
      humidityAllowedMaxCM4: "--",
      humidityAllowedMaxJM4: "--",
      humidityAllowedMaxCM6: "--",
      humidityAllowedMaxJM6: "--",
      humidityAllowedMaxCM8: "--",
      humidityAllowedMaxJM8: "--",
      humidityAllowedMaxCM10: "--",
      humidityAllowedMaxCE4: "--",
      humidityAllowedMaxJE2: "--",
      humidityAllowedMaxCE2: "--",
      humidityAllowedMaxCW1: "--",
      humidityAllowedMaxJW1: "--",
      humidityAllowedMaxCW3: "--",
      humidityAllowedMaxCM1: "--",
      humidityAllowedMaxJM1: "--",
      humidityAllowedMaxCM3: "--",
      humidityAllowedMaxJM3: "--",
      humidityAllowedMaxCM5: "--",
      humidityAllowedMaxJM5: "--",
      humidityAllowedMaxCM7: "--",
      humidityAllowedMaxJM7: "--",
      humidityAllowedMaxCM9: "--",
      humidityAllowedMaxCE3: "--",
      humidityAllowedMaxJE1: "--",
      humidityAllowedMaxCE1: "--",

      humidityAllowedMaxSensorCW2: "--",
      humidityAllowedMaxSensorJW2: "--",
      humidityAllowedMaxSensorCW4: "--",
      humidityAllowedMaxSensorCM2: "--",
      humidityAllowedMaxSensorJM2: "--",
      humidityAllowedMaxSensorCM4: "--",
      humidityAllowedMaxSensorJM4: "--",
      humidityAllowedMaxSensorCM6: "--",
      humidityAllowedMaxSensorJM6: "--",
      humidityAllowedMaxSensorCM8: "--",
      humidityAllowedMaxSensorJM8: "--",
      humidityAllowedMaxSensorCM10: "--",
      humidityAllowedMaxSensorCE4: "--",
      humidityAllowedMaxSensorJE2: "--",
      humidityAllowedMaxSensorCE2: "--",
      humidityAllowedMaxSensorCW1: "--",
      humidityAllowedMaxSensorJW1: "--",
      humidityAllowedMaxSensorCW3: "--",
      humidityAllowedMaxSensorCM1: "--",
      humidityAllowedMaxSensorJM1: "--",
      humidityAllowedMaxSensorCM3: "--",
      humidityAllowedMaxSensorJM3: "--",
      humidityAllowedMaxSensorCM5: "--",
      humidityAllowedMaxSensorJM5: "--",
      humidityAllowedMaxSensorCM7: "--",
      humidityAllowedMaxSensorJM7: "--",
      humidityAllowedMaxSensorCM9: "--",
      humidityAllowedMaxSensorCE3: "--",
      humidityAllowedMaxSensorJE1: "--",
      humidityAllowedMaxSensorCE1: "--",

      humidityAllowedMaxPlcCW2: "--",
      humidityAllowedMaxPlcJW2: "--",
      humidityAllowedMaxPlcCW4: "--",
      humidityAllowedMaxPlcCM2: "--",
      humidityAllowedMaxPlcJM2: "--",
      humidityAllowedMaxPlcCM4: "--",
      humidityAllowedMaxPlcJM4: "--",
      humidityAllowedMaxPlcCM6: "--",
      humidityAllowedMaxPlcJM6: "--",
      humidityAllowedMaxPlcCM8: "--",
      humidityAllowedMaxPlcJM8: "--",
      humidityAllowedMaxPlcCM10: "--",
      humidityAllowedMaxPlcCE4: "--",
      humidityAllowedMaxPlcJE2: "--",
      humidityAllowedMaxPlcCE2: "--",
      humidityAllowedMaxPlcCW1: "--",
      humidityAllowedMaxPlcJW1: "--",
      humidityAllowedMaxPlcCW3: "--",
      humidityAllowedMaxPlcCM1: "--",
      humidityAllowedMaxPlcJM1: "--",
      humidityAllowedMaxPlcCM3: "--",
      humidityAllowedMaxPlcJM3: "--",
      humidityAllowedMaxPlcCM5: "--",
      humidityAllowedMaxPlcJM5: "--",
      humidityAllowedMaxPlcCM7: "--",
      humidityAllowedMaxPlcJM7: "--",
      humidityAllowedMaxPlcCM9: "--",
      humidityAllowedMaxPlcCE3: "--",
      humidityAllowedMaxPlcJE1: "--",
      humidityAllowedMaxPlcCE1: "--",

      humidityAllowedMaxWinccCW2: "--",
      humidityAllowedMaxWinccJW2: "--",
      humidityAllowedMaxWinccCW4: "--",
      humidityAllowedMaxWinccCM2: "--",
      humidityAllowedMaxWinccJM2: "--",
      humidityAllowedMaxWinccCM4: "--",
      humidityAllowedMaxWinccJM4: "--",
      humidityAllowedMaxWinccCM6: "--",
      humidityAllowedMaxWinccJM6: "--",
      humidityAllowedMaxWinccCM8: "--",
      humidityAllowedMaxWinccJM8: "--",
      humidityAllowedMaxWinccCM10: "--",
      humidityAllowedMaxWinccCE4: "--",
      humidityAllowedMaxWinccJE2: "--",
      humidityAllowedMaxWinccCE2: "--",
      humidityAllowedMaxWinccCW1: "--",
      humidityAllowedMaxWinccJW1: "--",
      humidityAllowedMaxWinccCW3: "--",
      humidityAllowedMaxWinccCM1: "--",
      humidityAllowedMaxWinccJM1: "--",
      humidityAllowedMaxWinccCM3: "--",
      humidityAllowedMaxWinccJM3: "--",
      humidityAllowedMaxWinccCM5: "--",
      humidityAllowedMaxWinccJM5: "--",
      humidityAllowedMaxWinccCM7: "--",
      humidityAllowedMaxWinccJM7: "--",
      humidityAllowedMaxWinccCM9: "--",
      humidityAllowedMaxWinccCE3: "--",
      humidityAllowedMaxWinccJE1: "--",
      humidityAllowedMaxWinccCE1: "--",

      humidityAllowedMaxAnchorHuapingUp: "--",
      humidityAllowedMaxAnchorHuapingDown: "--",
      humidityAllowedMaxAnchorLijiangUp: "--",
      humidityAllowedMaxAnchorLijiangDown: "--",
      humidityAllowedMaxSaddleHuapingUp: "--",
      humidityAllowedMaxSaddleHuapingDown: "--",
      humidityAllowedMaxSaddleLijiangUp: "--",
      humidityAllowedMaxSaddleLijiangDown: "--",

      humidityAllowedMaxPlcAnchorHuapingUp: "--",
      humidityAllowedMaxPlcAnchorHuapingDown: "--",
      humidityAllowedMaxPlcAnchorLijiangUp: "--",
      humidityAllowedMaxPlcAnchorLijiangDown: "--",
      humidityAllowedMaxPlcSaddleHuapingUp: "--",
      humidityAllowedMaxPlcSaddleHuapingDown: "--",
      humidityAllowedMaxPlcSaddleLijiangUp: "--",
      humidityAllowedMaxPlcSaddleLijiangDown: "--",

      humidityAllowedMaxWinccAnchorHuapingUp: "--",
      humidityAllowedMaxWinccAnchorHuapingDown: "--",
      humidityAllowedMaxWinccAnchorLijiangUp: "--",
      humidityAllowedMaxWinccAnchorLijiangDown: "--",
      humidityAllowedMaxWinccSaddleHuapingUp: "--",
      humidityAllowedMaxWinccSaddleHuapingDown: "--",
      humidityAllowedMaxWinccSaddleLijiangUp: "--",
      humidityAllowedMaxWinccSaddleLijiangDown: "--",

      //humidity tooltip error
      humidityTooltipErrorCW2: "--",
      humidityTooltipErrorJW2: "--",
      humidityTooltipErrorCW4: "--",
      humidityTooltipErrorCM2: "--",
      humidityTooltipErrorJM2: "--",
      humidityTooltipErrorCM4: "--",
      humidityTooltipErrorJM4: "--",
      humidityTooltipErrorCM6: "--",
      humidityTooltipErrorJM6: "--",
      humidityTooltipErrorCM8: "--",
      humidityTooltipErrorJM8: "--",
      humidityTooltipErrorCM10: "--",
      humidityTooltipErrorCE4: "--",
      humidityTooltipErrorJE2: "--",
      humidityTooltipErrorCE2: "--",
      humidityTooltipErrorCW1: "--",
      humidityTooltipErrorJW1: "--",
      humidityTooltipErrorCW3: "--",
      humidityTooltipErrorCM1: "--",
      humidityTooltipErrorJM1: "--",
      humidityTooltipErrorCM3: "--",
      humidityTooltipErrorJM3: "--",
      humidityTooltipErrorCM5: "--",
      humidityTooltipErrorJM5: "--",
      humidityTooltipErrorCM7: "--",
      humidityTooltipErrorJM7: "--",
      humidityTooltipErrorCM9: "--",
      humidityTooltipErrorCE3: "--",
      humidityTooltipErrorJE1: "--",
      humidityTooltipErrorCE1: "--",

      humidityTooltipErrorSensorCW2: "--",
      humidityTooltipErrorSensorJW2: "--",
      humidityTooltipErrorSensorCW4: "--",
      humidityTooltipErrorSensorCM2: "--",
      humidityTooltipErrorSensorJM2: "--",
      humidityTooltipErrorSensorCM4: "--",
      humidityTooltipErrorSensorJM4: "--",
      humidityTooltipErrorSensorCM6: "--",
      humidityTooltipErrorSensorJM6: "--",
      humidityTooltipErrorSensorCM8: "--",
      humidityTooltipErrorSensorJM8: "--",
      humidityTooltipErrorSensorCM10: "--",
      humidityTooltipErrorSensorCE4: "--",
      humidityTooltipErrorSensorJE2: "--",
      humidityTooltipErrorSensorCE2: "--",
      humidityTooltipErrorSensorCW1: "--",
      humidityTooltipErrorSensorJW1: "--",
      humidityTooltipErrorSensorCW3: "--",
      humidityTooltipErrorSensorCM1: "--",
      humidityTooltipErrorSensorJM1: "--",
      humidityTooltipErrorSensorCM3: "--",
      humidityTooltipErrorSensorJM3: "--",
      humidityTooltipErrorSensorCM5: "--",
      humidityTooltipErrorSensorJM5: "--",
      humidityTooltipErrorSensorCM7: "--",
      humidityTooltipErrorSensorJM7: "--",
      humidityTooltipErrorSensorCM9: "--",
      humidityTooltipErrorSensorCE3: "--",
      humidityTooltipErrorSensorJE1: "--",
      humidityTooltipErrorSensorCE1: "--",

      humidityTooltipErrorPlcCW2: "--",
      humidityTooltipErrorPlcJW2: "--",
      humidityTooltipErrorPlcCW4: "--",
      humidityTooltipErrorPlcCM2: "--",
      humidityTooltipErrorPlcJM2: "--",
      humidityTooltipErrorPlcCM4: "--",
      humidityTooltipErrorPlcJM4: "--",
      humidityTooltipErrorPlcCM6: "--",
      humidityTooltipErrorPlcJM6: "--",
      humidityTooltipErrorPlcCM8: "--",
      humidityTooltipErrorPlcJM8: "--",
      humidityTooltipErrorPlcCM10: "--",
      humidityTooltipErrorPlcCE4: "--",
      humidityTooltipErrorPlcJE2: "--",
      humidityTooltipErrorPlcCE2: "--",
      humidityTooltipErrorPlcCW1: "--",
      humidityTooltipErrorPlcJW1: "--",
      humidityTooltipErrorPlcCW3: "--",
      humidityTooltipErrorPlcCM1: "--",
      humidityTooltipErrorPlcJM1: "--",
      humidityTooltipErrorPlcCM3: "--",
      humidityTooltipErrorPlcJM3: "--",
      humidityTooltipErrorPlcCM5: "--",
      humidityTooltipErrorPlcJM5: "--",
      humidityTooltipErrorPlcCM7: "--",
      humidityTooltipErrorPlcJM7: "--",
      humidityTooltipErrorPlcCM9: "--",
      humidityTooltipErrorPlcCE3: "--",
      humidityTooltipErrorPlcJE1: "--",
      humidityTooltipErrorPlcCE1: "--",

      humidityTooltipErrorWinccCW2: "--",
      humidityTooltipErrorWinccJW2: "--",
      humidityTooltipErrorWinccCW4: "--",
      humidityTooltipErrorWinccCM2: "--",
      humidityTooltipErrorWinccJM2: "--",
      humidityTooltipErrorWinccCM4: "--",
      humidityTooltipErrorWinccJM4: "--",
      humidityTooltipErrorWinccCM6: "--",
      humidityTooltipErrorWinccJM6: "--",
      humidityTooltipErrorWinccCM8: "--",
      humidityTooltipErrorWinccJM8: "--",
      humidityTooltipErrorWinccCM10: "--",
      humidityTooltipErrorWinccCE4: "--",
      humidityTooltipErrorWinccJE2: "--",
      humidityTooltipErrorWinccCE2: "--",
      humidityTooltipErrorWinccCW1: "--",
      humidityTooltipErrorWinccJW1: "--",
      humidityTooltipErrorWinccCW3: "--",
      humidityTooltipErrorWinccCM1: "--",
      humidityTooltipErrorWinccJM1: "--",
      humidityTooltipErrorWinccCM3: "--",
      humidityTooltipErrorWinccJM3: "--",
      humidityTooltipErrorWinccCM5: "--",
      humidityTooltipErrorWinccJM5: "--",
      humidityTooltipErrorWinccCM7: "--",
      humidityTooltipErrorWinccJM7: "--",
      humidityTooltipErrorWinccCM9: "--",
      humidityTooltipErrorWinccCE3: "--",
      humidityTooltipErrorWinccJE1: "--",
      humidityTooltipErrorWinccCE1: "--",

      humidityTooltipErrorAnchorHuapingUp: "--",
      humidityTooltipErrorAnchorHuapingDown: "--",
      humidityTooltipErrorAnchorLijiangUp: "--",
      humidityTooltipErrorAnchorLijiangDown: "--",
      humidityTooltipErrorSaddleHuapingUp: "--",
      humidityTooltipErrorSaddleHuapingDown: "--",
      humidityTooltipErrorSaddleLijiangUp: "--",
      humidityTooltipErrorSaddleLijiangDown: "--",

      humidityTooltipErrorPlcAnchorHuapingUp: "--",
      humidityTooltipErrorPlcAnchorHuapingDown: "--",
      humidityTooltipErrorPlcAnchorLijiangUp: "--",
      humidityTooltipErrorPlcAnchorLijiangDown: "--",
      humidityTooltipErrorPlcSaddleHuapingUp: "--",
      humidityTooltipErrorPlcSaddleHuapingDown: "--",
      humidityTooltipErrorPlcSaddleLijiangUp: "--",
      humidityTooltipErrorPlcSaddleLijiangDown: "--",

      humidityTooltipErrorWinccAnchorHuapingUp: "--",
      humidityTooltipErrorWinccAnchorHuapingDown: "--",
      humidityTooltipErrorWinccAnchorLijiangUp: "--",
      humidityTooltipErrorWinccAnchorLijiangDown: "--",
      humidityTooltipErrorWinccSaddleHuapingUp: "--",
      humidityTooltipErrorWinccSaddleHuapingDown: "--",
      humidityTooltipErrorWinccSaddleLijiangUp: "--",
      humidityTooltipErrorWinccSaddleLijiangDown: "--",

      dataNameIdDict: {
        //humidity, temperature
        humidityPlcCW1: "d3b1bf10-928e-4bb9-acd5-c1fee91e3b13",
        humidityPlcJW1: "59568709-cb4b-4db2-9f38-89bd3f8654f4",
        humidityPlcCW3: "585ee7e1-6c62-4992-aee0-41654b256764",
        humidityPlcCM1: "77525f00-ae8e-456a-91fd-c4071e3d4a83",
        humidityPlcJM1: "f11d54f0-fd0c-4027-86a8-e09482111b04",
        humidityPlcCM3: "6832b468-1aff-4d89-8ce9-c9e3d0cd1d59",
        humidityPlcJM3: "a1cdb39c-0441-429f-8a4f-92483bfee473",
        humidityPlcCM5: "25df4eac-6931-4548-87dd-6ddb19b68c37",
        humidityPlcCW2: "90d22f0d-6512-49fd-a29d-b3c27fafcf38",
        humidityPlcJW2: "3fbf669f-fc33-4547-b7e6-bfe99cd07a8c",
        humidityPlcCW4: "eb1b76de-5547-4723-bbb6-03e974ab3967",
        humidityPlcCM2: "4f3c2b6a-90db-4b4c-b2f2-d07cf3d1244b",
        humidityPlcJM2: "11f7f8d7-6b1e-4d64-930f-665299150ae5",
        humidityPlcCM4: "eff18d31-b607-48b6-9d71-64d0ff0cf0ec",
        humidityPlcJM4: "c46f342c-cca2-4e61-b760-b1286e9b88de",
        humidityPlcCM6: "65caee29-b17b-428a-ba82-9435729f327f",
        humidityPlcCE2: "2ddf63b0-0dd0-468b-8dbe-2ebe462ff478",
        humidityPlcJM5: "529c5386-1e87-40da-8a0b-9ac4ed303042",
        humidityPlcCM7: "e6d17c7b-0c5c-4e94-a7bc-18812f77bf79",
        humidityPlcJM7: "59a25ba1-9a6c-48da-8f44-33cfbb4af9af",
        humidityPlcCM9: "e42c6605-e745-4f96-9964-9d594ad2a761",
        humidityPlcCE3: "45331332-6dca-4362-bd9f-7be1588fda9e",
        humidityPlcJE1: "7b864e79-d40f-40e8-8b1b-aaca7bcb136e",
        humidityPlcCE1: "11af71f8-53c7-4d59-ba6b-1c3540388741",
        humidityPlcJM6: "b391772b-0689-4ff3-890c-580fca195d42",
        humidityPlcCM8: "8f2e2734-2e65-485a-9c80-7428c7862a62",
        humidityPlcJM8: "0509a1f1-96ef-46ad-80eb-3fcfd2e7e19e",
        humidityPlcCM10: "fcf3e6a5-7f17-44fe-8337-a3fed5247c6c",
        humidityPlcCE4: "3c409ee8-d442-449a-b02a-c4b6f9af8183",
        humidityPlcJE2: "9253b5e9-e790-4b63-bfcb-0c980f5b0d52",

        temperaturePlcCW1: "bc3daead-c1e8-45b8-9093-8b114917a4a2",
        temperaturePlcJW1: "af8d306b-bfed-46e6-9cb8-2064aa70f5f3",
        temperaturePlcCW3: "fc67b23f-62a8-477e-aa9a-6f2e0e5bb8d7",
        temperaturePlcCM1: "6c67d51c-0fb3-4852-b215-0416713ec328",
        temperaturePlcJM1: "408d3025-9741-4f0d-a7c6-45d9b84cd1ff",
        temperaturePlcCM3: "1720f135-ecd4-42ef-bf06-4f160c6dbefd",
        temperaturePlcJM3: "d8e4a943-aaec-4cc8-b858-3af45e60c74c",
        temperaturePlcCM5: "4d154d1b-d93b-4bc4-a6de-32466d21c6cd",
        temperaturePlcCW2: "0d0e36af-c561-40ed-86ab-9d72e65f504f",
        temperaturePlcJW2: "9befd448-99d1-4283-94f9-40508d2f97a8",
        temperaturePlcCW4: "2727007f-0d42-4cb8-8700-550a86227b9c",
        temperaturePlcCM2: "64c5c896-5008-41f3-81b3-6e35a5bf2f9e",
        temperaturePlcJM2: "660c3741-de65-422f-b436-0074f8c5615f",
        temperaturePlcCM4: "25b91cf5-f994-4bfc-9269-5d6d0e3edb70",
        temperaturePlcJM4: "7287b7ce-7e91-4aac-9b61-bc0659f65317",
        temperaturePlcCM6: "c6f3bd7b-8086-4bdb-886b-076d54b8bc96",
        temperaturePlcCE2: "d4e491b5-33f8-4745-9a22-749786c1195e",
        temperaturePlcJM5: "52f5303d-8d4e-4e6c-939a-6e0c0c76212e",
        temperaturePlcCM7: "0e3175f4-c245-46f1-ab5b-6bde6a303a3b",
        temperaturePlcJM7: "d8660752-2c8e-4f8c-9d5e-74032cb6ecc7",
        temperaturePlcCM9: "326859bd-11e5-42aa-a311-12cb7200c941",
        temperaturePlcCE3: "72d696cd-0eb2-4265-a456-c6b1432a15ab",
        temperaturePlcJE1: "5340cf5c-4e92-4a93-bf6d-bd77ba54679c",
        temperaturePlcCE1: "8c6c6b62-c475-42c2-a521-bae4a5e4c384",
        temperaturePlcJM6: "ed93ed3f-001c-423b-95d8-d22092d4de33",
        temperaturePlcCM8: "876fb749-f8fc-4e6b-951c-61d20555e0a8",
        temperaturePlcJM8: "c8c27bf9-defe-47c1-80a5-85cb184867a7",
        temperaturePlcCM10: "e22a9d94-defc-4607-9b90-0438f934c6ac",
        temperaturePlcCE4: "d78792d3-d008-4c74-b8f7-ebbf249be8af",
        temperaturePlcJE2: "67ee9ddf-4f7d-4a5f-a82c-64c639261fc2",

        pressurePlcCW1: "5e6fda41-1a0b-46b2-8435-4b15651774ee",
        pressurePlcJW1: "2e02e812-f083-4b46-9487-ba9d7d152b4f",
        pressurePlcCW3: "c1ec9c66-1798-4461-9885-52f5a4630667",
        pressurePlcCM1: "387c4fc6-cd24-4dcb-a204-381bd06733cf",
        pressurePlcJM1: "6e779288-f209-49bb-a861-39585fe4f593",
        pressurePlcCM3: "80b0a2a9-fd46-4023-8666-7c6a89d84f83",
        pressurePlcJM3: "e2d39521-8683-49aa-8a46-bb70e6cf5545",
        pressurePlcCM5: "013708f0-3ced-4da1-a6c5-9cdeed972ed9",
        pressurePlcCW2: "daba687d-3993-4173-9c41-2d4d4eeeab5c",
        pressurePlcJW2: "604d777c-4bdd-4315-a05b-ade07020fe3e",
        pressurePlcCW4: "e7bb1983-e64c-43e4-98e2-fdf6a1b89206",
        pressurePlcCM2: "3c7af35e-5692-4f14-94de-62a941e64a55",
        pressurePlcJM2: "a1cf9f29-c817-4738-8855-cd2dbfc02ef5",
        pressurePlcCM4: "7e8939ca-3551-4353-afa7-da7302d62bd7",
        pressurePlcJM4: "e02ce7b1-e7df-4381-8fbc-c74205285600",
        pressurePlcCM6: "3f337b5b-6f5d-4c25-8c5b-ded2f44713b6",
        pressurePlcCE2: "0837046b-957b-479a-9dda-d332bacd2a15",
        pressurePlcJM5: "0a2dae30-1617-4bd7-9c2d-83c59b74747f",
        pressurePlcCM7: "68deba3d-7aee-45fa-abe1-f8b7715d3d4f",
        pressurePlcJM7: "e58bab8b-07c8-4226-911f-b8950e358ee5",
        pressurePlcCM9: "97abed65-3429-4677-b0fd-975585952709",
        pressurePlcCE3: "1fdde553-ce3e-4fe0-bcab-ce3e50d76b16",
        pressurePlcJE1: "ce915931-33d6-49fa-8432-2b2f89ce8727",
        pressurePlcCE1: "9da484aa-f3d9-49b9-9147-1f7cd2ec99fd",
        pressurePlcJM6: "3b066c59-3831-4db7-adfe-82b3f89d25e3",
        pressurePlcCM8: "ade8c283-d1bc-456b-9db6-0240e49962b1",
        pressurePlcJM8: "720c78c8-75c7-40a8-bf00-39fb08d7e2d1",
        pressurePlcCM10: "54c3ce1f-0819-4ea0-a643-0d4300c51c5d",
        pressurePlcCE4: "12ba3585-965f-45ba-ae70-afd194d51480",
        pressurePlcJE2: "0a586411-9e69-48e8-8508-d755d02850cd",

        humiditySensorCW1: "c3617f7f-bcd2-4f64-8d4a-fd2eb0bdb2d2",
        humiditySensorJW1: "GUID",
        humiditySensorCW3: "GUID",
        humiditySensorCM1: "GUID",
        humiditySensorJM1: "GUID",
        humiditySensorCM3: "GUID",
        humiditySensorJM3: "GUID",
        humiditySensorCM5: "GUID",
        humiditySensorCW2: "1c65b203-333d-4b0d-b786-e25277291c5f",
        humiditySensorJW2: "74ff63c2-3f8b-4009-8839-c42c241861ba",
        humiditySensorCW4: "e5d813ee-7c38-4fea-9c7d-443a685d950c",
        humiditySensorCM2: "GUID",
        humiditySensorJM2: "97546f0e-32e6-4aee-9b21-9268223f49d4",
        humiditySensorCM4: "9d74a908-2114-4299-b316-0cedf9ce8a3e",
        humiditySensorJM4: "GUID",
        humiditySensorCM6: "GUID",
        humiditySensorCE2: "GUID",
        humiditySensorJM5: "GUID",
        humiditySensorCM7: "GUID",
        humiditySensorJM7: "GUID",
        humiditySensorCM9: "GUID",
        humiditySensorCE3: "GUID",
        humiditySensorJE1: "GUID",
        humiditySensorCE1: "GUID",
        humiditySensorJM6: "249156f1-12c2-4853-b883-8cf9c1fcfb68",
        humiditySensorCM8: "GUID",
        humiditySensorJM8: "GUID",
        humiditySensorCM10: "GUID",
        humiditySensorCE4: "GUID",
        humiditySensorJE2: "GUID",

        temperatureSensorCW1: "d05682de-b9fb-47ef-a4b2-b56ae7a4e07a",
        temperatureSensorJW1: "GUID",
        temperatureSensorCW3: "GUID",
        temperatureSensorCM1: "GUID",
        temperatureSensorJM1: "GUID",
        temperatureSensorCM3: "GUID",
        temperatureSensorJM3: "GUID",
        temperatureSensorCM5: "GUID",
        temperatureSensorCW2: "16954084-5840-4c13-b11c-62ac92476588",
        temperatureSensorJW2: "2770e50c-13a8-44b2-801f-5eaeec0ba1ad",
        temperatureSensorCW4: "e89de2fc-e63f-4641-a208-83ab89bddb70",
        temperatureSensorCM2: "GUID",
        temperatureSensorJM2: "59e02329-84a5-4109-8021-053bae2cba03",
        temperatureSensorCM4: "c6690b32-6ec9-46ff-9108-1592e0c72f02",
        temperatureSensorJM4: "GUID",
        temperatureSensorCM6: "GUID",
        temperatureSensorCE2: "GUID",
        temperatureSensorJM5: "GUID",
        temperatureSensorCM7: "GUID",
        temperatureSensorJM7: "GUID",
        temperatureSensorCM9: "GUID",
        temperatureSensorCE3: "GUID",
        temperatureSensorJE1: "GUID",
        temperatureSensorCE1: "GUID",
        temperatureSensorJM6: "413aca6d-2cee-401b-a5f0-d7ef87d5c423",
        temperatureSensorCM8: "GUID",
        temperatureSensorJM8: "GUID",
        temperatureSensorCM10: "GUID",
        temperatureSensorCE4: "GUID",
        temperatureSensorJE2: "GUID",

        pressureSensorCW1: "e07b1ea5-32f2-49ca-a205-fa597538a553",
        pressureSensorJW1: "GUID",
        pressureSensorCW3: "GUID",
        pressureSensorCM1: "GUID",
        pressureSensorJM1: "GUID",
        pressureSensorCM3: "GUID",
        pressureSensorJM3: "GUID",
        pressureSensorCM5: "GUID",
        pressureSensorCW2: "dcb7198a-b294-4b0c-832e-a2fb58da6068",
        pressureSensorJW2: "0dc18c19-ab7b-4171-9275-9f961cf6e96d",
        pressureSensorCW4: "9c565506-20f2-46b2-979f-ea3efaab9ac5",
        pressureSensorCM2: "GUID",
        pressureSensorJM2: "7a4ff505-27e4-4dc1-a50c-7a8b3c6f1756",
        pressureSensorCM4: "e9a5e7e3-d334-433d-97ea-31b6c6b8ab64",
        pressureSensorJM4: "GUID",
        pressureSensorCM6: "GUID",
        pressureSensorCE2: "GUID",
        pressureSensorJM5: "GUID",
        pressureSensorCM7: "GUID",
        pressureSensorJM7: "GUID",
        pressureSensorCM9: "GUID",
        pressureSensorCE3: "GUID",
        pressureSensorJE1: "GUID",
        pressureSensorCE1: "GUID",
        pressureSensorJM6: "7adcad38-228d-488c-9368-44de09d8f616",
        pressureSensorCM8: "GUID",
        pressureSensorJM8: "GUID",
        pressureSensorCM10: "GUID",
        pressureSensorCE4: "GUID",
        pressureSensorJE2: "GUID",

        humidityWinccCW2: "64e7910d-befc-4ffd-9250-20d28ca6d078",
        humidityWinccJW2: "fe7cbbbd-524b-4a66-8908-aeae993929be",
        humidityWinccCW4: "0ef83c5e-1434-495a-aca6-68608e1fe155",
        humidityWinccCM2: "2e7cc90d-43a5-49c5-9822-468793d394f3",
        humidityWinccJM2: "e7a76fe8-9c80-4aa8-b762-019084452be9",
        humidityWinccCM4: "4d010112-fb53-4ad8-8163-3dfb3ffb7d37",
        humidityWinccJM4: "e3e055cb-7cba-429a-8dcb-dd136f5a8c93",
        humidityWinccCM6: "6a2d8f01-b7f8-49f9-aaea-fe16a9d33f20",
        humidityWinccJM6: "127aa07e-af03-471e-9e61-6e10e3c67f76",
        humidityWinccCM8: "12a18e1d-9e4e-4861-bb70-c6d3716f8a5e",
        humidityWinccJM8: "b1144cfe-9dc2-4fda-9e2d-44cdde9a7930",
        humidityWinccCM10: "e29c1371-60df-4619-98e5-2e0f7e24379e",
        humidityWinccCE4: "b9beaec9-d4fa-4866-a8bc-c94056099adf",
        humidityWinccJE2: "8e978520-0b50-4e12-9fce-504ba3ce2936",
        humidityWinccCE2: "aac73783-14c2-4c6b-bea9-2291c60619a9",
        humidityWinccCW1: "023c7930-4fdc-4c8c-b04b-16cc62e3e899",
        humidityWinccJW1: "175a8808-663b-465c-a45d-ac9040a83c6c",
        humidityWinccCW3: "17e2f31c-3e86-4118-904b-15f8a1592d3d",
        humidityWinccCM1: "79cadd01-fa71-471b-880a-d1abc1594687",
        humidityWinccJM1: "19bf6aaa-d59e-4621-a9d5-64c28171ead1",
        humidityWinccCM3: "4e3376a3-d575-4187-b2cf-d7bf0b9c83bd",
        humidityWinccJM3: "76697d7e-07ad-4a11-9fc1-9e338188acff",
        humidityWinccCM5: "b8be41df-0112-441b-84c9-976722130b5d",
        humidityWinccJM5: "8d04e509-24e5-4c10-91da-a92bf4889311",
        humidityWinccCM7: "f48b39bd-cfd8-4606-92dd-86cd1bfbb530",
        humidityWinccJM7: "c6e3ee67-14ed-4a19-b869-23a50833d8c0",
        humidityWinccCM9: "398a841f-aed5-4375-9375-97d575bf7824",
        humidityWinccCE3: "ef6a9e20-40e3-4dd2-a78b-3612a5c3b574",
        humidityWinccJE1: "6ead0e95-4ff5-4d8b-9b41-ef54453dcbd3",
        humidityWinccCE1: "90ae78c7-542d-45cc-81d4-fd24083a71f5",

        temperatureWinccCW2: "fcf5d4ee-7678-4ec8-8fa9-3643adb49f65",
        temperatureWinccJW2: "68cee81c-11c5-435a-8f72-407c876576ad",
        temperatureWinccCW4: "4a84aad1-dbb5-462b-91a6-20aaad5eba83",
        temperatureWinccCM2: "8f1dbc52-e14f-4e1c-82b7-ad2b9a91941e",
        temperatureWinccJM2: "f8aa2106-9cf4-40bd-9336-c05a29388df6",
        temperatureWinccCM4: "906ff7e7-1df4-4025-8b7f-01617133cd71",
        temperatureWinccJM4: "d442a8b5-260d-479e-956c-79f0f1313430",
        temperatureWinccCM6: "8b78a804-71fd-40a0-92ef-344e28b3d0ed",
        temperatureWinccJM6: "81b7a61f-eb96-479a-967f-ade1f7883cdc",
        temperatureWinccCM8: "9ab1d10c-feb4-4158-9677-cddfd64cf32a",
        temperatureWinccJM8: "62b4772f-5287-4115-9bc3-04de264dc936",
        temperatureWinccCM10: "1f611c19-6084-4260-98ca-c880261b0e12",
        temperatureWinccCE4: "a655bd0f-b8da-46f3-bcae-1e41cb577769",
        temperatureWinccJE2: "631df59e-4d29-4e80-bb90-969e20aa2e3a",
        temperatureWinccCE2: "32044469-8add-4659-b443-93a30c6e860c",
        temperatureWinccCW1: "535ce2d8-e9f2-4b26-8472-bc4ff890f465",
        temperatureWinccJW1: "c5d5b898-8b33-4321-899f-62ae3dcd65fc",
        temperatureWinccCW3: "133d8653-2097-49a6-964b-c7c00cbd784a",
        temperatureWinccCM1: "f4315907-0104-4cbc-b95f-2dde57404f8c",
        temperatureWinccJM1: "2c30baf9-a5a7-477a-9740-bf13a1a8048d",
        temperatureWinccCM3: "85d9b723-8997-4f25-9261-3ecd29f0be9c",
        temperatureWinccJM3: "6e74379a-2120-4983-9712-a6fa66645af7",
        temperatureWinccCM5: "73e040f2-19f3-45a9-90b1-5476a1cc156d",
        temperatureWinccJM5: "629eb945-7d70-415b-af21-36b7b9bd1df0",
        temperatureWinccCM7: "f06d2c67-6982-4a5a-a54c-baba9a23ae21",
        temperatureWinccJM7: "e723edf9-31a1-4397-9c5a-6eb7c2d650ff",
        temperatureWinccCM9: "69740019-e608-451d-a9bf-4644a33cb066",
        temperatureWinccCE3: "66354edc-51b4-4477-b248-9cb275bfbf0b",
        temperatureWinccJE1: "afd6b71b-1765-4136-9087-3d4a62fd0e3e",
        temperatureWinccCE1: "833234be-41db-4563-9358-d03363468529",

        pressureWinccCW1: "ebd3bfc7-9f9f-4134-8a72-cc46302416b9",
        pressureWinccJW1: "5d2f0f24-5362-4cb5-baec-c41226089177",
        pressureWinccCW3: "3cd124f1-1fa1-4a99-bf16-120da2859dc3",
        pressureWinccCM1: "9d429e13-060b-4343-b036-f579a856f20c",
        pressureWinccJM1: "fb1838e7-aec8-4600-a77e-77221f79ab5a",
        pressureWinccCM3: "594079ae-f507-45b7-9bcf-8f4e33cdbf0b",
        pressureWinccJM3: "29c93b41-8d45-4ade-843e-aac753acf58b",
        pressureWinccCM5: "1f36daa3-de92-434a-ad0a-e2494239a29b",
        pressureWinccCW2: "f2e18dd3-a4b7-4117-b858-f68b9eb997f9",
        pressureWinccJW2: "bc9cdfdd-17b4-489f-9a11-63f0e2a21809",
        pressureWinccCW4: "17b80375-5028-40f0-9102-f5f36b463d43",
        pressureWinccCM2: "f6470632-012c-48d1-a956-e89e6731e0ec",
        pressureWinccJM2: "9ac9d980-cfe0-42d1-bbd5-2a15e206795b",
        pressureWinccCM4: "943b9b2b-9928-4aca-a57b-2cb20aec84c5",
        pressureWinccJM4: "0e850e01-bbe5-4859-892f-c944e6339685",
        pressureWinccCM6: "2730ac34-1574-4baa-8f21-efa992d69310",
        pressureWinccCE1: "d986b4f3-51c2-4db0-a016-1b23b13a5571",
        pressureWinccJE1: "115a2116-1dff-45e9-a2f5-5ee43091f2ce",
        pressureWinccCE3: "89e6d9f1-09d5-4266-8632-3ecb7ec57ba0",
        pressureWinccCM9: "96022f67-db06-4d9e-afcb-9ea38616c0c6",
        pressureWinccJM7: "6fb603a5-3de4-4a88-893e-0cf7f19e78fd",
        pressureWinccCM7: "e07aa949-09a1-4677-bac0-119829cf67aa",
        pressureWinccJM5: "312e0027-b223-42e2-aee5-dc6740c09473",
        pressureWinccCE2: "3d8082cb-4dd7-40c0-a52f-a4f0aa5de0ee",
        pressureWinccJE2: "ee0cfd12-d530-485c-be94-7f10dba9880f",
        pressureWinccCE4: "bb1a188f-8423-4b23-bbca-d69f36b2beb3",
        pressureWinccCM10: "0bd96037-446d-41d3-8d55-a0a4db202d54",
        pressureWinccJM8: "32d00c00-60b7-4815-a712-405d88537a82",
        pressureWinccCM8: "94a0d346-78f5-4a32-a1f8-93c06e44f74c",
        pressureWinccJM6: "5aad7371-6265-49b8-869c-42dc9aa2d678",

        humidityPlcAnchorHuapingUp: "4a7f5073-f3d0-4b4d-b634-c976ce9d368b",
        humidityPlcAnchorHuapingDown: "813fba70-f844-49b1-bb64-2626fdd163ce",
        humidityPlcAnchorLijiangUp: "843efc8d-6a4c-4971-b5e6-00c76024409d",
        humidityPlcAnchorLijiangDown: "2f239958-d279-4c92-8665-9fe80e674f14",
        humidityPlcSaddleHuapingUp: "8323a745-9db9-4f63-b45c-042c3f4896c1",
        humidityPlcSaddleHuapingDown: "0477ab3a-0172-4b9e-86f0-3114af1aeefa",
        humidityPlcSaddleLijiangUp: "587bea23-68b7-46d4-a598-239a2a80d9ba",
        humidityPlcSaddleLijiangDown: "bea9d2a5-d043-4deb-8084-ac6d2847ed62",

        temperaturePlcAnchorHuapingUp: "43d053ee-d873-4257-9c3b-e42251d06dde",
        temperaturePlcAnchorHuapingDown: "b8bda62e-5830-44a6-91d8-9a9710c83bd1",
        temperaturePlcAnchorLijiangUp: "59d08c7c-666e-49b5-8367-81f061c0cf4b",
        temperaturePlcAnchorLijiangDown: "f538caba-0613-4fb9-9014-9db2783eca4f",
        temperaturePlcSaddleHuapingUp: "96374612-a30a-4fe6-afce-afac2d546619",
        temperaturePlcSaddleHuapingDown: "e7533199-f8a0-47b1-ae6b-4b2c587f07e6",
        temperaturePlcSaddleLijiangUp: "fea20446-9aef-430c-b73b-402e18c73d40",
        temperaturePlcSaddleLijiangDown: "18954876-d90c-4770-95d4-0d0e13c82390",

        humidityWinccAnchorHuapingUp: "5c2dab2d-f45e-45ea-9da4-8b398b114b28",
        humidityWinccAnchorHuapingDown: "d4e84dcb-b8f3-442b-8984-0946a0d0e9f5",
        humidityWinccAnchorLijiangUp: "719d1f76-5a17-4b34-ad9f-affbc312ee98",
        humidityWinccAnchorLijiangDown: "b5269f1c-e44e-4e2c-a035-5c69b4523fe8",
        humidityWinccSaddleHuapingUp: "4002431e-8b97-459a-9e4b-5454e143023b",
        humidityWinccSaddleHuapingDown: "f4eed4a2-c3b2-41e0-87d0-f83c0c078f73",
        humidityWinccSaddleLijiangUp: "79e95616-000b-4c13-8b80-52eb48f5228b",
        humidityWinccSaddleLijiangDown: "8b315c32-2871-4c97-b6bf-e2430b9166f4",

        temperatureWinccAnchorHuapingUp: "c122b9fc-728d-4637-a05e-aec74ab83c33",
        temperatureWinccAnchorHuapingDown: "b0d741f7-ac2b-413d-b14a-59a379da5a0a",
        temperatureWinccAnchorLijiangUp: "3ea05222-c56e-4853-abd6-46a4c3e7c2ab",
        temperatureWinccAnchorLijiangDown: "905b6ad8-2635-431b-9cdd-022d8847e08d",
        temperatureWinccSaddleHuapingUp: "e89264d0-f690-4357-ac52-83f2c2e09d33",
        temperatureWinccSaddleHuapingDown: "726dd1f0-a938-4ef8-a36d-a30b60a188b4",
        temperatureWinccSaddleLijiangUp: "7e6e762a-8b6f-4df0-8ecb-cf93c3178154",
        temperatureWinccSaddleLijiangDown: "92225508-7745-4266-bc1a-6a1871c3492f",

        //running
        runningPlcAnchorHuapingUp: "f8906873-6dc8-4e6e-a148-56eb9c54d0f4",
        runningPlcAnchorHuapingDown: "b2b448c0-1d04-4ac2-9fb1-ac5ce6650104",
        runningPlcAnchorLijiangUp: "84a9a6eb-602e-4298-8190-f7e676b292b9",
        runningPlcAnchorLijiangDown: "c9ca8a39-5d7a-4b97-8337-2bce0506bd07",
        runningPlcSaddleHuapingUp: "e111b66d-7679-4474-834d-26cc66f691b5",
        runningPlcSaddleHuapingDown: "711fe04b-cffe-49ae-924d-76e7a41cf45c",
        runningPlcSaddleLijiangUp: "c82a4e6f-5b67-45c9-9266-fa8f68d06f43",
        runningPlcSaddleLijiangDown: "2a654bf3-076c-4de9-90f4-30439c27439d",

        runningWinccAnchorHuapingUp: "72a78f89-7b67-4b99-add5-bc9a41479f8b",
        runningWinccAnchorHuapingDown: "6dff3e48-a93f-448b-8ca1-727786cd9dfa",
        runningWinccAnchorLijiangUp: "b7ecb9c2-0fe2-4aca-b9e6-28d9f2194ddf",
        runningWinccAnchorLijiangDown: "0a6bb24b-6367-4272-b0d4-50c75b6344d6",
        runningWinccSaddleHuapingUp: "56227bbd-095b-4be9-b156-245bbf8535f3",
        runningWinccSaddleHuapingDown: "a1c0da5a-4229-450f-b7cc-20f1d9d63e99",
        runningWinccSaddleLijiangUp: "df087d58-7133-4fb3-a864-73a491afcaaa",
        runningWinccSaddleLijiangDown: "7e4b7ae5-7af5-4dc4-bc45-db687fe8bdd7",

        //malfunction
        malfunctionPlcAnchorHuapingUp: "257f6e15-3a5c-4a96-9119-cba316308911",
        malfunctionPlcAnchorHuapingDown: "0163547d-92fc-47d0-8ab8-8bc43507d975",
        malfunctionPlcAnchorLijiangUp: "8328fb32-5d09-4c70-8100-374534309aea",
        malfunctionPlcAnchorLijiangDown: "4b54207e-5a10-4569-9af3-e9d5cdb487d6",
        malfunctionPlcSaddleHuapingUp: "04145654-be1e-4bc5-a892-7b07612d2fe9",
        malfunctionPlcSaddleHuapingDown: "20ce53df-7ba5-4ae8-a314-26da5d7baf0d",
        malfunctionPlcSaddleLijiangUp: "9e9ee40b-510e-4e36-b0b3-49d66e02a706",
        malfunctionPlcSaddleLijiangDown: "84f02e7b-e3e1-418a-9b23-d688a06709d0",

        malfunctionWinccAnchorHuapingUp: "de03c625-98c6-4022-bfed-a3ebf993e188",
        malfunctionWinccAnchorHuapingDown: "ac9baa1d-55f5-484e-afc6-55128767b665",
        malfunctionWinccAnchorLijiangUp: "1945ac01-4771-4796-b397-24e5544fa161",
        malfunctionWinccAnchorLijiangDown: "374f45bb-7ae4-4309-8214-a8fd93f23cc6",
        malfunctionWinccSaddleHuapingUp: "b205f5df-4f86-4374-972d-00f4495c6719",
        malfunctionWinccSaddleHuapingDown: "2eb29923-8129-4a82-b94c-3ff1b0e081cb",
        malfunctionWinccSaddleLijiangUp: "c2833409-c1c5-467a-bf88-95b32e57722b",
        malfunctionWinccSaddleLijiangDown: "79e2c532-a478-439f-9afc-fd46532f32b7",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxPlcCW1: "d3b1bf10-928e-4bb9-acd5-c1fee91e3b13",
        humidityAllowedMaxPlcJW1: "59568709-cb4b-4db2-9f38-89bd3f8654f4",
        humidityAllowedMaxPlcCW3: "585ee7e1-6c62-4992-aee0-41654b256764",
        humidityAllowedMaxPlcCM1: "77525f00-ae8e-456a-91fd-c4071e3d4a83",
        humidityAllowedMaxPlcJM1: "f11d54f0-fd0c-4027-86a8-e09482111b04",
        humidityAllowedMaxPlcCM3: "6832b468-1aff-4d89-8ce9-c9e3d0cd1d59",
        humidityAllowedMaxPlcJM3: "a1cdb39c-0441-429f-8a4f-92483bfee473",
        humidityAllowedMaxPlcCM5: "25df4eac-6931-4548-87dd-6ddb19b68c37",
        humidityAllowedMaxPlcCW2: "90d22f0d-6512-49fd-a29d-b3c27fafcf38",
        humidityAllowedMaxPlcJW2: "3fbf669f-fc33-4547-b7e6-bfe99cd07a8c",
        humidityAllowedMaxPlcCW4: "eb1b76de-5547-4723-bbb6-03e974ab3967",
        humidityAllowedMaxPlcCM2: "4f3c2b6a-90db-4b4c-b2f2-d07cf3d1244b",
        humidityAllowedMaxPlcJM2: "11f7f8d7-6b1e-4d64-930f-665299150ae5",
        humidityAllowedMaxPlcCM4: "eff18d31-b607-48b6-9d71-64d0ff0cf0ec",
        humidityAllowedMaxPlcJM4: "c46f342c-cca2-4e61-b760-b1286e9b88de",
        humidityAllowedMaxPlcCM6: "65caee29-b17b-428a-ba82-9435729f327f",
        humidityAllowedMaxPlcCE2: "2ddf63b0-0dd0-468b-8dbe-2ebe462ff478",
        humidityAllowedMaxPlcJM5: "529c5386-1e87-40da-8a0b-9ac4ed303042",
        humidityAllowedMaxPlcCM7: "e6d17c7b-0c5c-4e94-a7bc-18812f77bf79",
        humidityAllowedMaxPlcJM7: "59a25ba1-9a6c-48da-8f44-33cfbb4af9af",
        humidityAllowedMaxPlcCM9: "e42c6605-e745-4f96-9964-9d594ad2a761",
        humidityAllowedMaxPlcCE3: "45331332-6dca-4362-bd9f-7be1588fda9e",
        humidityAllowedMaxPlcJE1: "7b864e79-d40f-40e8-8b1b-aaca7bcb136e",
        humidityAllowedMaxPlcCE1: "11af71f8-53c7-4d59-ba6b-1c3540388741",
        humidityAllowedMaxPlcJM6: "b391772b-0689-4ff3-890c-580fca195d42",
        humidityAllowedMaxPlcCM8: "8f2e2734-2e65-485a-9c80-7428c7862a62",
        humidityAllowedMaxPlcJM8: "0509a1f1-96ef-46ad-80eb-3fcfd2e7e19e",
        humidityAllowedMaxPlcCM10: "fcf3e6a5-7f17-44fe-8337-a3fed5247c6c",
        humidityAllowedMaxPlcCE4: "3c409ee8-d442-449a-b02a-c4b6f9af8183",
        humidityAllowedMaxPlcJE2: "9253b5e9-e790-4b63-bfcb-0c980f5b0d52",

        humidityAllowedMaxSensorCW1: "c3617f7f-bcd2-4f64-8d4a-fd2eb0bdb2d2",
        humidityAllowedMaxSensorJW1: "GUID",
        humidityAllowedMaxSensorCW3: "GUID",
        humidityAllowedMaxSensorCM1: "GUID",
        humidityAllowedMaxSensorJM1: "GUID",
        humidityAllowedMaxSensorCM3: "GUID",
        humidityAllowedMaxSensorJM3: "GUID",
        humidityAllowedMaxSensorCM5: "GUID",
        humidityAllowedMaxSensorCW2: "1c65b203-333d-4b0d-b786-e25277291c5f",
        humidityAllowedMaxSensorJW2: "74ff63c2-3f8b-4009-8839-c42c241861ba",
        humidityAllowedMaxSensorCW4: "e5d813ee-7c38-4fea-9c7d-443a685d950c",
        humidityAllowedMaxSensorCM2: "GUID",
        humidityAllowedMaxSensorJM2: "97546f0e-32e6-4aee-9b21-9268223f49d4",
        humidityAllowedMaxSensorCM4: "9d74a908-2114-4299-b316-0cedf9ce8a3e",
        humidityAllowedMaxSensorJM4: "GUID",
        humidityAllowedMaxSensorCM6: "GUID",
        humidityAllowedMaxSensorCE2: "GUID",
        humidityAllowedMaxSensorJM5: "GUID",
        humidityAllowedMaxSensorCM7: "GUID",
        humidityAllowedMaxSensorJM7: "GUID",
        humidityAllowedMaxSensorCM9: "GUID",
        humidityAllowedMaxSensorCE3: "GUID",
        humidityAllowedMaxSensorJE1: "GUID",
        humidityAllowedMaxSensorCE1: "GUID",
        humidityAllowedMaxSensorJM6: "249156f1-12c2-4853-b883-8cf9c1fcfb68",
        humidityAllowedMaxSensorCM8: "GUID",
        humidityAllowedMaxSensorJM8: "GUID",
        humidityAllowedMaxSensorCM10: "GUID",
        humidityAllowedMaxSensorCE4: "GUID",
        humidityAllowedMaxSensorJE2: "GUID",

        humidityAllowedMaxWinccCW2: "64e7910d-befc-4ffd-9250-20d28ca6d078",
        humidityAllowedMaxWinccJW2: "fe7cbbbd-524b-4a66-8908-aeae993929be",
        humidityAllowedMaxWinccCW4: "0ef83c5e-1434-495a-aca6-68608e1fe155",
        humidityAllowedMaxWinccCM2: "2e7cc90d-43a5-49c5-9822-468793d394f3",
        humidityAllowedMaxWinccJM2: "e7a76fe8-9c80-4aa8-b762-019084452be9",
        humidityAllowedMaxWinccCM4: "4d010112-fb53-4ad8-8163-3dfb3ffb7d37",
        humidityAllowedMaxWinccJM4: "e3e055cb-7cba-429a-8dcb-dd136f5a8c93",
        humidityAllowedMaxWinccCM6: "6a2d8f01-b7f8-49f9-aaea-fe16a9d33f20",
        humidityAllowedMaxWinccJM6: "127aa07e-af03-471e-9e61-6e10e3c67f76",
        humidityAllowedMaxWinccCM8: "12a18e1d-9e4e-4861-bb70-c6d3716f8a5e",
        humidityAllowedMaxWinccJM8: "b1144cfe-9dc2-4fda-9e2d-44cdde9a7930",
        humidityAllowedMaxWinccCM10: "e29c1371-60df-4619-98e5-2e0f7e24379e",
        humidityAllowedMaxWinccCE4: "b9beaec9-d4fa-4866-a8bc-c94056099adf",
        humidityAllowedMaxWinccJE2: "8e978520-0b50-4e12-9fce-504ba3ce2936",
        humidityAllowedMaxWinccCE2: "aac73783-14c2-4c6b-bea9-2291c60619a9",
        humidityAllowedMaxWinccCW1: "023c7930-4fdc-4c8c-b04b-16cc62e3e899",
        humidityAllowedMaxWinccJW1: "175a8808-663b-465c-a45d-ac9040a83c6c",
        humidityAllowedMaxWinccCW3: "17e2f31c-3e86-4118-904b-15f8a1592d3d",
        humidityAllowedMaxWinccCM1: "79cadd01-fa71-471b-880a-d1abc1594687",
        humidityAllowedMaxWinccJM1: "19bf6aaa-d59e-4621-a9d5-64c28171ead1",
        humidityAllowedMaxWinccCM3: "4e3376a3-d575-4187-b2cf-d7bf0b9c83bd",
        humidityAllowedMaxWinccJM3: "76697d7e-07ad-4a11-9fc1-9e338188acff",
        humidityAllowedMaxWinccCM5: "b8be41df-0112-441b-84c9-976722130b5d",
        humidityAllowedMaxWinccJM5: "8d04e509-24e5-4c10-91da-a92bf4889311",
        humidityAllowedMaxWinccCM7: "f48b39bd-cfd8-4606-92dd-86cd1bfbb530",
        humidityAllowedMaxWinccJM7: "c6e3ee67-14ed-4a19-b869-23a50833d8c0",
        humidityAllowedMaxWinccCM9: "398a841f-aed5-4375-9375-97d575bf7824",
        humidityAllowedMaxWinccCE3: "ef6a9e20-40e3-4dd2-a78b-3612a5c3b574",
        humidityAllowedMaxWinccJE1: "6ead0e95-4ff5-4d8b-9b41-ef54453dcbd3",
        humidityAllowedMaxWinccCE1: "90ae78c7-542d-45cc-81d4-fd24083a71f5",

        humidityAllowedMaxPlcAnchorHuapingUp: "4a7f5073-f3d0-4b4d-b634-c976ce9d368b",
        humidityAllowedMaxPlcAnchorHuapingDown: "813fba70-f844-49b1-bb64-2626fdd163ce",
        humidityAllowedMaxPlcAnchorLijiangUp: "843efc8d-6a4c-4971-b5e6-00c76024409d",
        humidityAllowedMaxPlcAnchorLijiangDown: "2f239958-d279-4c92-8665-9fe80e674f14",
        humidityAllowedMaxPlcSaddleHuapingUp: "8323a745-9db9-4f63-b45c-042c3f4896c1",
        humidityAllowedMaxPlcSaddleHuapingDown: "0477ab3a-0172-4b9e-86f0-3114af1aeefa",
        humidityAllowedMaxPlcSaddleLijiangUp: "587bea23-68b7-46d4-a598-239a2a80d9ba",
        humidityAllowedMaxPlcSaddleLijiangDown: "bea9d2a5-d043-4deb-8084-ac6d2847ed62",

        humidityAllowedMaxWinccAnchorHuapingUp: "5c2dab2d-f45e-45ea-9da4-8b398b114b28",
        humidityAllowedMaxWinccAnchorHuapingDown: "d4e84dcb-b8f3-442b-8984-0946a0d0e9f5",
        humidityAllowedMaxWinccAnchorLijiangUp: "719d1f76-5a17-4b34-ad9f-affbc312ee98",
        humidityAllowedMaxWinccAnchorLijiangDown: "b5269f1c-e44e-4e2c-a035-5c69b4523fe8",
        humidityAllowedMaxWinccSaddleHuapingUp: "4002431e-8b97-459a-9e4b-5454e143023b",
        humidityAllowedMaxWinccSaddleHuapingDown: "f4eed4a2-c3b2-41e0-87d0-f83c0c078f73",
        humidityAllowedMaxWinccSaddleLijiangUp: "79e95616-000b-4c13-8b80-52eb48f5228b",
        humidityAllowedMaxWinccSaddleLijiangDown: "8b315c32-2871-4c97-b6bf-e2430b9166f4",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humiditySensorCW2: "errorSensorCW2",
        humiditySensorJW2: "errorSensorJW2",
        humiditySensorCW4: "errorSensorCW4",
        humiditySensorCM2: "errorSensorCM2",
        humiditySensorJM2: "errorSensorJM2",
        humiditySensorCM4: "errorSensorCM4",
        humiditySensorJM4: "errorSensorJM4",
        humiditySensorCM6: "errorSensorCM6",
        humiditySensorJM6: "errorSensorJM6",
        humiditySensorCM8: "errorSensorCM8",
        humiditySensorJM8: "errorSensorJM8",
        humiditySensorCM10: "errorSensorCM10",
        humiditySensorCE4: "errorSensorCE4",
        humiditySensorJE2: "errorSensorJE2",
        humiditySensorCE2: "errorSensorCE2",
        humiditySensorCW1: "errorSensorCW1",
        humiditySensorJW1: "errorSensorJW1",
        humiditySensorCW3: "errorSensorCW3",
        humiditySensorCM1: "errorSensorCM1",
        humiditySensorJM1: "errorSensorJM1",
        humiditySensorCM3: "errorSensorCM3",
        humiditySensorJM3: "errorSensorJM3",
        humiditySensorCM5: "errorSensorCM5",
        humiditySensorJM5: "errorSensorJM5",
        humiditySensorCM7: "errorSensorCM7",
        humiditySensorJM7: "errorSensorJM7",
        humiditySensorCM9: "errorSensorCM9",
        humiditySensorCE3: "errorSensorCE3",
        humiditySensorJE1: "errorSensorJE1",
        humiditySensorCE1: "errorSensorCE1",

        temperaturerSensorCW2: "errorSensorCW2",
        temperaturerSensorJW2: "errorSensorJW2",
        temperaturerSensorCW4: "errorSensorCW4",
        temperaturerSensorCM2: "errorSensorCM2",
        temperaturerSensorJM2: "errorSensorJM2",
        temperaturerSensorCM4: "errorSensorCM4",
        temperaturerSensorJM4: "errorSensorJM4",
        temperaturerSensorCM6: "errorSensorCM6",
        temperaturerSensorJM6: "errorSensorJM6",
        temperaturerSensorCM8: "errorSensorCM8",
        temperaturerSensorJM8: "errorSensorJM8",
        temperaturerSensorCM10: "errorSensorCM10",
        temperaturerSensorCE4: "errorSensorCE4",
        temperaturerSensorJE2: "errorSensorJE2",
        temperaturerSensorCE2: "errorSensorCE2",
        temperaturerSensorCW1: "errorSensorCW1",
        temperaturerSensorJW1: "errorSensorJW1",
        temperaturerSensorCW3: "errorSensorCW3",
        temperaturerSensorCM1: "errorSensorCM1",
        temperaturerSensorJM1: "errorSensorJM1",
        temperaturerSensorCM3: "errorSensorCM3",
        temperaturerSensorJM3: "errorSensorJM3",
        temperaturerSensorCM5: "errorSensorCM5",
        temperaturerSensorJM5: "errorSensorJM5",
        temperaturerSensorCM7: "errorSensorCM7",
        temperaturerSensorJM7: "errorSensorJM7",
        temperaturerSensorCM9: "errorSensorCM9",
        temperaturerSensorCE3: "errorSensorCE3",
        temperaturerSensorJE1: "errorSensorJE1",
        temperaturerSensorCE1: "errorSensorCE1",

        pressureSensorCW2: "errorSensorCW2",
        pressureSensorJW2: "errorSensorJW2",
        pressureSensorCW4: "errorSensorCW4",
        pressureSensorCM2: "errorSensorCM2",
        pressureSensorJM2: "errorSensorJM2",
        pressureSensorCM4: "errorSensorCM4",
        pressureSensorJM4: "errorSensorJM4",
        pressureSensorCM6: "errorSensorCM6",
        pressureSensorJM6: "errorSensorJM6",
        pressureSensorCM8: "errorSensorCM8",
        pressureSensorJM8: "errorSensorJM8",
        pressureSensorCM10: "errorSensorCM10",
        pressureSensorCE4: "errorSensorCE4",
        pressureSensorJE2: "errorSensorJE2",
        pressureSensorCE2: "errorSensorCE2",
        pressureSensorCW1: "errorSensorCW1",
        pressureSensorJW1: "errorSensorJW1",
        pressureSensorCW3: "errorSensorCW3",
        pressureSensorCM1: "errorSensorCM1",
        pressureSensorJM1: "errorSensorJM1",
        pressureSensorCM3: "errorSensorCM3",
        pressureSensorJM3: "errorSensorJM3",
        pressureSensorCM5: "errorSensorCM5",
        pressureSensorJM5: "errorSensorJM5",
        pressureSensorCM7: "errorSensorCM7",
        pressureSensorJM7: "errorSensorJM7",
        pressureSensorCM9: "errorSensorCM9",
        pressureSensorCE3: "errorSensorCE3",
        pressureSensorJE1: "errorSensorJE1",
        pressureSensorCE1: "errorSensorCE1",

        humidityPlcCW2: "errorPlcCW2",
        humidityPlcJW2: "errorPlcJW2",
        humidityPlcCW4: "errorPlcCW4",
        humidityPlcCM2: "errorPlcCM2",
        humidityPlcJM2: "errorPlcJM2",
        humidityPlcCM4: "errorPlcCM4",
        humidityPlcJM4: "errorPlcJM4",
        humidityPlcCM6: "errorPlcCM6",
        humidityPlcJM6: "errorPlcJM6",
        humidityPlcCM8: "errorPlcCM8",
        humidityPlcJM8: "errorPlcJM8",
        humidityPlcCM10: "errorPlcCM10",
        humidityPlcCE4: "errorPlcCE4",
        humidityPlcJE2: "errorPlcJE2",
        humidityPlcCE2: "errorPlcCE2",
        humidityPlcCW1: "errorPlcCW1",
        humidityPlcJW1: "errorPlcJW1",
        humidityPlcCW3: "errorPlcCW3",
        humidityPlcCM1: "errorPlcCM1",
        humidityPlcJM1: "errorPlcJM1",
        humidityPlcCM3: "errorPlcCM3",
        humidityPlcJM3: "errorPlcJM3",
        humidityPlcCM5: "errorPlcCM5",
        humidityPlcJM5: "errorPlcJM5",
        humidityPlcCM7: "errorPlcCM7",
        humidityPlcJM7: "errorPlcJM7",
        humidityPlcCM9: "errorPlcCM9",
        humidityPlcCE3: "errorPlcCE3",
        humidityPlcJE1: "errorPlcJE1",
        humidityPlcCE1: "errorPlcCE1",

        temperaturerPlcCW2: "errorPlcCW2",
        temperaturerPlcJW2: "errorPlcJW2",
        temperaturerPlcCW4: "errorPlcCW4",
        temperaturerPlcCM2: "errorPlcCM2",
        temperaturerPlcJM2: "errorPlcJM2",
        temperaturerPlcCM4: "errorPlcCM4",
        temperaturerPlcJM4: "errorPlcJM4",
        temperaturerPlcCM6: "errorPlcCM6",
        temperaturerPlcJM6: "errorPlcJM6",
        temperaturerPlcCM8: "errorPlcCM8",
        temperaturerPlcJM8: "errorPlcJM8",
        temperaturerPlcCM10: "errorPlcCM10",
        temperaturerPlcCE4: "errorPlcCE4",
        temperaturerPlcJE2: "errorPlcJE2",
        temperaturerPlcCE2: "errorPlcCE2",
        temperaturerPlcCW1: "errorPlcCW1",
        temperaturerPlcJW1: "errorPlcJW1",
        temperaturerPlcCW3: "errorPlcCW3",
        temperaturerPlcCM1: "errorPlcCM1",
        temperaturerPlcJM1: "errorPlcJM1",
        temperaturerPlcCM3: "errorPlcCM3",
        temperaturerPlcJM3: "errorPlcJM3",
        temperaturerPlcCM5: "errorPlcCM5",
        temperaturerPlcJM5: "errorPlcJM5",
        temperaturerPlcCM7: "errorPlcCM7",
        temperaturerPlcJM7: "errorPlcJM7",
        temperaturerPlcCM9: "errorPlcCM9",
        temperaturerPlcCE3: "errorPlcCE3",
        temperaturerPlcJE1: "errorPlcJE1",
        temperaturerPlcCE1: "errorPlcCE1",

        pressurePlcCW2: "errorPlcCW2",
        pressurePlcJW2: "errorPlcJW2",
        pressurePlcCW4: "errorPlcCW4",
        pressurePlcCM2: "errorPlcCM2",
        pressurePlcJM2: "errorPlcJM2",
        pressurePlcCM4: "errorPlcCM4",
        pressurePlcJM4: "errorPlcJM4",
        pressurePlcCM6: "errorPlcCM6",
        pressurePlcJM6: "errorPlcJM6",
        pressurePlcCM8: "errorPlcCM8",
        pressurePlcJM8: "errorPlcJM8",
        pressurePlcCM10: "errorPlcCM10",
        pressurePlcCE4: "errorPlcCE4",
        pressurePlcJE2: "errorPlcJE2",
        pressurePlcCE2: "errorPlcCE2",
        pressurePlcCW1: "errorPlcCW1",
        pressurePlcJW1: "errorPlcJW1",
        pressurePlcCW3: "errorPlcCW3",
        pressurePlcCM1: "errorPlcCM1",
        pressurePlcJM1: "errorPlcJM1",
        pressurePlcCM3: "errorPlcCM3",
        pressurePlcJM3: "errorPlcJM3",
        pressurePlcCM5: "errorPlcCM5",
        pressurePlcJM5: "errorPlcJM5",
        pressurePlcCM7: "errorPlcCM7",
        pressurePlcJM7: "errorPlcJM7",
        pressurePlcCM9: "errorPlcCM9",
        pressurePlcCE3: "errorPlcCE3",
        pressurePlcJE1: "errorPlcJE1",
        pressurePlcCE1: "errorPlcCE1",

        humidityWinccCW2: "errorWinccCW2",
        humidityWinccJW2: "errorWinccJW2",
        humidityWinccCW4: "errorWinccCW4",
        humidityWinccCM2: "errorWinccCM2",
        humidityWinccJM2: "errorWinccJM2",
        humidityWinccCM4: "errorWinccCM4",
        humidityWinccJM4: "errorWinccJM4",
        humidityWinccCM6: "errorWinccCM6",
        humidityWinccJM6: "errorWinccJM6",
        humidityWinccCM8: "errorWinccCM8",
        humidityWinccJM8: "errorWinccJM8",
        humidityWinccCM10: "errorWinccCM10",
        humidityWinccCE4: "errorWinccCE4",
        humidityWinccJE2: "errorWinccJE2",
        humidityWinccCE2: "errorWinccCE2",
        humidityWinccCW1: "errorWinccCW1",
        humidityWinccJW1: "errorWinccJW1",
        humidityWinccCW3: "errorWinccCW3",
        humidityWinccCM1: "errorWinccCM1",
        humidityWinccJM1: "errorWinccJM1",
        humidityWinccCM3: "errorWinccCM3",
        humidityWinccJM3: "errorWinccJM3",
        humidityWinccCM5: "errorWinccCM5",
        humidityWinccJM5: "errorWinccJM5",
        humidityWinccCM7: "errorWinccCM7",
        humidityWinccJM7: "errorWinccJM7",
        humidityWinccCM9: "errorWinccCM9",
        humidityWinccCE3: "errorWinccCE3",
        humidityWinccJE1: "errorWinccJE1",
        humidityWinccCE1: "errorWinccCE1",

        temperaturerWinccCW2: "errorWinccCW2",
        temperaturerWinccJW2: "errorWinccJW2",
        temperaturerWinccCW4: "errorWinccCW4",
        temperaturerWinccCM2: "errorWinccCM2",
        temperaturerWinccJM2: "errorWinccJM2",
        temperaturerWinccCM4: "errorWinccCM4",
        temperaturerWinccJM4: "errorWinccJM4",
        temperaturerWinccCM6: "errorWinccCM6",
        temperaturerWinccJM6: "errorWinccJM6",
        temperaturerWinccCM8: "errorWinccCM8",
        temperaturerWinccJM8: "errorWinccJM8",
        temperaturerWinccCM10: "errorWinccCM10",
        temperaturerWinccCE4: "errorWinccCE4",
        temperaturerWinccJE2: "errorWinccJE2",
        temperaturerWinccCE2: "errorWinccCE2",
        temperaturerWinccCW1: "errorWinccCW1",
        temperaturerWinccJW1: "errorWinccJW1",
        temperaturerWinccCW3: "errorWinccCW3",
        temperaturerWinccCM1: "errorWinccCM1",
        temperaturerWinccJM1: "errorWinccJM1",
        temperaturerWinccCM3: "errorWinccCM3",
        temperaturerWinccJM3: "errorWinccJM3",
        temperaturerWinccCM5: "errorWinccCM5",
        temperaturerWinccJM5: "errorWinccJM5",
        temperaturerWinccCM7: "errorWinccCM7",
        temperaturerWinccJM7: "errorWinccJM7",
        temperaturerWinccCM9: "errorWinccCM9",
        temperaturerWinccCE3: "errorWinccCE3",
        temperaturerWinccJE1: "errorWinccJE1",
        temperaturerWinccCE1: "errorWinccCE1",

        pressureWinccCW2: "errorWinccCW2",
        pressureWinccJW2: "errorWinccJW2",
        pressureWinccCW4: "errorWinccCW4",
        pressureWinccCM2: "errorWinccCM2",
        pressureWinccJM2: "errorWinccJM2",
        pressureWinccCM4: "errorWinccCM4",
        pressureWinccJM4: "errorWinccJM4",
        pressureWinccCM6: "errorWinccCM6",
        pressureWinccJM6: "errorWinccJM6",
        pressureWinccCM8: "errorWinccCM8",
        pressureWinccJM8: "errorWinccJM8",
        pressureWinccCM10: "errorWinccCM10",
        pressureWinccCE4: "errorWinccCE4",
        pressureWinccJE2: "errorWinccJE2",
        pressureWinccCE2: "errorWinccCE2",
        pressureWinccCW1: "errorWinccCW1",
        pressureWinccJW1: "errorWinccJW1",
        pressureWinccCW3: "errorWinccCW3",
        pressureWinccCM1: "errorWinccCM1",
        pressureWinccJM1: "errorWinccJM1",
        pressureWinccCM3: "errorWinccCM3",
        pressureWinccJM3: "errorWinccJM3",
        pressureWinccCM5: "errorWinccCM5",
        pressureWinccJM5: "errorWinccJM5",
        pressureWinccCM7: "errorWinccCM7",
        pressureWinccJM7: "errorWinccJM7",
        pressureWinccCM9: "errorWinccCM9",
        pressureWinccCE3: "errorWinccCE3",
        pressureWinccJE1: "errorWinccJE1",
        pressureWinccCE1: "errorWinccCE1",

        humidityPlcAnchorHuapingUp: "errorPlcAnchorHuapingUp",
        humidityPlcAnchorHuapingDown: "errorPlcAnchorHuapingDown",
        humidityPlcAnchorLijiangUp: "errorPlcAnchorLijiangUp",
        humidityPlcAnchorLijiangDown: "errorPlcAnchorLijiangDown",
        humidityPlcSaddleHuapingUp: "errorPlcSaddleHuapingUp",
        humidityPlcSaddleHuapingDown: "errorPlcSaddleHuapingDown",
        humidityPlcSaddleLijiangUp: "errorPlcSaddleLijiangUp",
        humidityPlcSaddleLijiangDown: "errorPlcSaddleLijiangDown",

        humidityWinccAnchorHuapingUp: "errorWinccAnchorHuapingUp",
        humidityWinccAnchorHuapingDown: "errorWinccAnchorHuapingDown",
        humidityWinccAnchorLijiangUp: "errorWinccAnchorLijiangUp",
        humidityWinccAnchorLijiangDown: "errorWinccAnchorLijiangDown",
        humidityWinccSaddleHuapingUp: "errorWinccSaddleHuapingUp",
        humidityWinccSaddleHuapingDown: "errorWinccSaddleHuapingDown",
        humidityWinccSaddleLijiangUp: "errorWinccSaddleLijiangUp",
        humidityWinccSaddleLijiangDown: "errorWinccSaddleLijiangDown",

        temperaturePlcAnchorHuapingUp: "errorPlcAnchorHuapingUp",
        temperaturePlcAnchorHuapingDown: "errorPlcAnchorHuapingDown",
        temperaturePlcAnchorLijiangUp: "errorPlcAnchorLijiangUp",
        temperaturePlcAnchorLijiangDown: "errorPlcAnchorLijiangDown",
        temperaturePlcSaddleHuapingUp: "errorPlcSaddleHuapingUp",
        temperaturePlcSaddleHuapingDown: "errorPlcSaddleHuapingDown",
        temperaturePlcSaddleLijiangUp: "errorPlcSaddleLijiangUp",
        temperaturePlcSaddleLijiangDown: "errorPlcSaddleLijiangDown",

        temperatureWinccAnchorHuapingUp: "errorWinccAnchorHuapingUp",
        temperatureWinccAnchorHuapingDown: "errorWinccAnchorHuapingDown",
        temperatureWinccAnchorLijiangUp: "errorWinccAnchorLijiangUp",
        temperatureWinccAnchorLijiangDown: "errorWinccAnchorLijiangDown",
        temperatureWinccSaddleHuapingUp: "errorWinccSaddleHuapingUp",
        temperatureWinccSaddleHuapingDown: "errorWinccSaddleHuapingDown",
        temperatureWinccSaddleLijiangUp: "errorWinccSaddleLijiangUp",
        temperatureWinccSaddleLijiangDown: "errorWinccSaddleLijiangDown",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionPlcAnchorHuapingUp: "errorPlcAnchorHuapingUp",
        malfunctionPlcAnchorHuapingDown: "errorPlcAnchorHuapingDown",
        malfunctionPlcAnchorLijiangUp: "errorPlcAnchorLijiangUp",
        malfunctionPlcAnchorLijiangDown: "errorPlcAnchorLijiangDown",
        malfunctionPlcSaddleHuapingUp: "errorPlcSaddleHuapingUp",
        malfunctionPlcSaddleHuapingDown: "errorPlcSaddleHuapingDown",
        malfunctionPlcSaddleLijiangUp: "errorPlcSaddleLijiangUp",
        malfunctionPlcSaddleLijiangDown: "errorPlcSaddleLijiangDown",

        malfunctionWinccAnchorHuapingUp: "errorWinccAnchorHuapingUp",
        malfunctionWinccAnchorHuapingDown: "errorWinccAnchorHuapingDown",
        malfunctionWinccAnchorLijiangUp: "errorWinccAnchorLijiangUp",
        malfunctionWinccAnchorLijiangDown: "errorWinccAnchorLijiangDown",
        malfunctionWinccSaddleHuapingUp: "errorWinccSaddleHuapingUp",
        malfunctionWinccSaddleHuapingDown: "errorWinccSaddleHuapingDown",
        malfunctionWinccSaddleLijiangUp: "errorWinccSaddleLijiangUp",
        malfunctionWinccSaddleLijiangDown: "errorWinccSaddleLijiangDown",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humiditySensorCW2: "humidityTooltipErrorSensorCW2",
        humiditySensorJW2: "humidityTooltipErrorSensorJW2",
        humiditySensorCW4: "humidityTooltipErrorSensorCW4",
        humiditySensorCM2: "humidityTooltipErrorSensorCM2",
        humiditySensorJM2: "humidityTooltipErrorSensorJM2",
        humiditySensorCM4: "humidityTooltipErrorSensorCM4",
        humiditySensorJM4: "humidityTooltipErrorSensorJM4",
        humiditySensorCM6: "humidityTooltipErrorSensorCM6",
        humiditySensorJM6: "humidityTooltipErrorSensorJM6",
        humiditySensorCM8: "humidityTooltipErrorSensorCM8",
        humiditySensorJM8: "humidityTooltipErrorSensorJM8",
        humiditySensorCM10: "humidityTooltipErrorSensorCM10",
        humiditySensorCE4: "humidityTooltipErrorSensorCE4",
        humiditySensorJE2: "humidityTooltipErrorSensorJE2",
        humiditySensorCE2: "humidityTooltipErrorSensorCE2",
        humiditySensorCW1: "humidityTooltipErrorSensorCW1",
        humiditySensorJW1: "humidityTooltipErrorSensorJW1",
        humiditySensorCW3: "humidityTooltipErrorSensorCW3",
        humiditySensorCM1: "humidityTooltipErrorSensorCM1",
        humiditySensorJM1: "humidityTooltipErrorSensorJM1",
        humiditySensorCM3: "humidityTooltipErrorSensorCM3",
        humiditySensorJM3: "humidityTooltipErrorSensorJM3",
        humiditySensorCM5: "humidityTooltipErrorSensorCM5",
        humiditySensorJM5: "humidityTooltipErrorSensorJM5",
        humiditySensorCM7: "humidityTooltipErrorSensorCM7",
        humiditySensorJM7: "humidityTooltipErrorSensorJM7",
        humiditySensorCM9: "humidityTooltipErrorSensorCM9",
        humiditySensorCE3: "humidityTooltipErrorSensorCE3",
        humiditySensorJE1: "humidityTooltipErrorSensorJE1",
        humiditySensorCE1: "humidityTooltipErrorSensorCE1",

        humidityPlcCW2: "humidityTooltipErrorPlcCW2",
        humidityPlcJW2: "humidityTooltipErrorPlcJW2",
        humidityPlcCW4: "humidityTooltipErrorPlcCW4",
        humidityPlcCM2: "humidityTooltipErrorPlcCM2",
        humidityPlcJM2: "humidityTooltipErrorPlcJM2",
        humidityPlcCM4: "humidityTooltipErrorPlcCM4",
        humidityPlcJM4: "humidityTooltipErrorPlcJM4",
        humidityPlcCM6: "humidityTooltipErrorPlcCM6",
        humidityPlcJM6: "humidityTooltipErrorPlcJM6",
        humidityPlcCM8: "humidityTooltipErrorPlcCM8",
        humidityPlcJM8: "humidityTooltipErrorPlcJM8",
        humidityPlcCM10: "humidityTooltipErrorPlcCM10",
        humidityPlcCE4: "humidityTooltipErrorPlcCE4",
        humidityPlcJE2: "humidityTooltipErrorPlcJE2",
        humidityPlcCE2: "humidityTooltipErrorPlcCE2",
        humidityPlcCW1: "humidityTooltipErrorPlcCW1",
        humidityPlcJW1: "humidityTooltipErrorPlcJW1",
        humidityPlcCW3: "humidityTooltipErrorPlcCW3",
        humidityPlcCM1: "humidityTooltipErrorPlcCM1",
        humidityPlcJM1: "humidityTooltipErrorPlcJM1",
        humidityPlcCM3: "humidityTooltipErrorPlcCM3",
        humidityPlcJM3: "humidityTooltipErrorPlcJM3",
        humidityPlcCM5: "humidityTooltipErrorPlcCM5",
        humidityPlcJM5: "humidityTooltipErrorPlcJM5",
        humidityPlcCM7: "humidityTooltipErrorPlcCM7",
        humidityPlcJM7: "humidityTooltipErrorPlcJM7",
        humidityPlcCM9: "humidityTooltipErrorPlcCM9",
        humidityPlcCE3: "humidityTooltipErrorPlcCE3",
        humidityPlcJE1: "humidityTooltipErrorPlcJE1",
        humidityPlcCE1: "humidityTooltipErrorPlcCE1",

        humidityWinccCW2: "humidityTooltipErrorWinccCW2",
        humidityWinccJW2: "humidityTooltipErrorWinccJW2",
        humidityWinccCW4: "humidityTooltipErrorWinccCW4",
        humidityWinccCM2: "humidityTooltipErrorWinccCM2",
        humidityWinccJM2: "humidityTooltipErrorWinccJM2",
        humidityWinccCM4: "humidityTooltipErrorWinccCM4",
        humidityWinccJM4: "humidityTooltipErrorWinccJM4",
        humidityWinccCM6: "humidityTooltipErrorWinccCM6",
        humidityWinccJM6: "humidityTooltipErrorWinccJM6",
        humidityWinccCM8: "humidityTooltipErrorWinccCM8",
        humidityWinccJM8: "humidityTooltipErrorWinccJM8",
        humidityWinccCM10: "humidityTooltipErrorWinccCM10",
        humidityWinccCE4: "humidityTooltipErrorWinccCE4",
        humidityWinccJE2: "humidityTooltipErrorWinccJE2",
        humidityWinccCE2: "humidityTooltipErrorWinccCE2",
        humidityWinccCW1: "humidityTooltipErrorWinccCW1",
        humidityWinccJW1: "humidityTooltipErrorWinccJW1",
        humidityWinccCW3: "humidityTooltipErrorWinccCW3",
        humidityWinccCM1: "humidityTooltipErrorWinccCM1",
        humidityWinccJM1: "humidityTooltipErrorWinccJM1",
        humidityWinccCM3: "humidityTooltipErrorWinccCM3",
        humidityWinccJM3: "humidityTooltipErrorWinccJM3",
        humidityWinccCM5: "humidityTooltipErrorWinccCM5",
        humidityWinccJM5: "humidityTooltipErrorWinccJM5",
        humidityWinccCM7: "humidityTooltipErrorWinccCM7",
        humidityWinccJM7: "humidityTooltipErrorWinccJM7",
        humidityWinccCM9: "humidityTooltipErrorWinccCM9",
        humidityWinccCE3: "humidityTooltipErrorWinccCE3",
        humidityWinccJE1: "humidityTooltipErrorWinccJE1",
        humidityWinccCE1: "humidityTooltipErrorWinccCE1",

        humidityPlcAnchorHuapingUp: "humidityTooltipErrorPlcAnchorHuapingUp",
        humidityPlcAnchorHuapingDown: "humidityTooltipErrorPlcAnchorHuapingDown",
        humidityPlcAnchorLijiangUp: "humidityTooltipErrorPlcAnchorLijiangUp",
        humidityPlcAnchorLijiangDown: "humidityTooltipErrorPlcAnchorLijiangDown",
        humidityPlcSaddleHuapingUp: "humidityTooltipErrorPlcSaddleHuapingUp",
        humidityPlcSaddleHuapingDown: "humidityTooltipErrorPlcSaddleHuapingDown",
        humidityPlcSaddleLijiangUp: "humidityTooltipErrorPlcSaddleLijiangUp",
        humidityPlcSaddleLijiangDown: "humidityTooltipErrorPlcSaddleLijiangDown",

        humidityWinccAnchorHuapingUp: "humidityTooltipErrorWinccAnchorHuapingUp",
        humidityWinccAnchorHuapingDown: "humidityTooltipErrorWinccAnchorHuapingDown",
        humidityWinccAnchorLijiangUp: "humidityTooltipErrorWinccAnchorLijiangUp",
        humidityWinccAnchorLijiangDown: "humidityTooltipErrorWinccAnchorLijiangDown",
        humidityWinccSaddleHuapingUp: "humidityTooltipErrorWinccSaddleHuapingUp",
        humidityWinccSaddleHuapingDown: "humidityTooltipErrorWinccSaddleHuapingDown",
        humidityWinccSaddleLijiangUp: "humidityTooltipErrorWinccSaddleLijiangUp",
        humidityWinccSaddleLijiangDown: "humidityTooltipErrorWinccSaddleLijiangDown",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningPlcAnchorHuapingUp: "runningClassPlcAnchorHuapingUp",
        runningPlcAnchorHuapingDown: "runningClassPlcAnchorHuapingDown",
        runningPlcAnchorLijiangUp: "runningClassPlcAnchorLijiangUp",
        runningPlcAnchorLijiangDown: "runningClassPlcAnchorLijiangDown",
        runningPlcSaddleHuapingUp: "runningClassPlcSaddleHuapingUp",
        runningPlcSaddleHuapingDown: "runningClassPlcSaddleHuapingDown",
        runningPlcSaddleLijiangUp: "runningClassPlcSaddleLijiangUp",
        runningPlcSaddleLijiangDown: "runningClassPlcSaddleLijiangDown",

        runningWinccAnchorHuapingUp: "runningClassWinccAnchorHuapingUp",
        runningWinccAnchorHuapingDown: "runningClassWinccAnchorHuapingDown",
        runningWinccAnchorLijiangUp: "runningClassWinccAnchorLijiangUp",
        runningWinccAnchorLijiangDown: "runningClassWinccAnchorLijiangDown",
        runningWinccSaddleHuapingUp: "runningClassWinccSaddleHuapingUp",
        runningWinccSaddleHuapingDown: "runningClassWinccSaddleHuapingDown",
        runningWinccSaddleLijiangUp: "runningClassWinccSaddleLijiangUp",
        runningWinccSaddleLijiangDown: "runningClassWinccSaddleLijiangDown",
      },

      //station id list
      stationIdList: [
        "351dbb31-4db5-4bd0-b572-8173261fdd6f",
        "fa5b3f6c-ceab-4205-b52c-66b42cfcc00d",
        "2d1c521f-a564-4293-83df-f34eaff00872",
        "1a8e4981-4931-4429-a238-dd4765d126a6",
        "408f5bda-f87d-4bfe-bb6f-7c5a92a48081",
        "35d83882-3b43-4c8c-a2cc-f70aded67a4a",
        "37120826-bd6c-4bde-bcb2-b81a5616f7e2",
        "d9adc8f4-560a-4cfa-b609-85b9ed72dde0",
        "33e62935-660d-4064-8f1a-428e5f7e48f6",
        "1be9549a-6642-4b51-b55b-e00de7ec08db",
        "6015a418-b7b1-497f-b1de-a9aa65e47891",
        "994ba00b-ce96-45fb-949b-2b505cc870d3",
        "ec951680-cab7-45c9-8406-35eee2cfb716",
        "6aea0e2d-41bd-4dd3-b481-14cd7ca2f589",
        "ada15150-d814-4526-baa2-f2a8ff5d38c7",
        "7b409dd1-4e96-4061-b8cf-8a7d87f1f5f0",
        "8ff543c4-b47f-4b38-a67b-7ac2f4e84d19",
        "93148943-41ba-411b-b091-aafd59f4ba59",
      ],

      humidityDataNameList: [
        "humidityCW2",
        "humidityJW2",
        "humidityCW4",
        "humidityCM2",
        "humidityJM2",
        "humidityCM4",
        "humidityJM4",
        "humidityCM6",
        "humidityJM6",
        "humidityCM8",
        "humidityJM8",
        "humidityCM10",
        "humidityCE4",
        "humidityJE2",
        "humidityCE2",
        "humidityCW1",
        "humidityJW1",
        "humidityCW3",
        "humidityCM1",
        "humidityJM1",
        "humidityCM3",
        "humidityJM3",
        "humidityCM5",
        "humidityJM5",
        "humidityCM7",
        "humidityJM7",
        "humidityCM9",
        "humidityCE3",
        "humidityJE1",
        "humidityCE1",

        "humidityAnchorHuapingUp",
        "humidityAnchorHuapingDown",
        "humidityAnchorLijiangUp",
        "humidityAnchorLijiangDown",
        "humiditySaddleHuapingUp",
        "humiditySaddleHuapingDown",
        "humiditySaddleLijiangUp",
        "humiditySaddleLijiangDown",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.chooseDataSourceAndSetData();
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    chooseDataSourceAndSetData() {
      for (let humidityDataName of this.humidityDataNameList) {
        let dataSource = undefined;
        let dataSourceName = undefined;

        //sensor > plc > wincc(default)
        let humiditySensorName = humidityDataName.replace("humidity", "humiditySensor");
        let humidityPlcName = humidityDataName.replace("humidity", "humidityPlc");
        if (
          this[humiditySensorName] &&
          this[humiditySensorName] !== null &&
          Number(this[humiditySensorName]) &&
          Number(this[humiditySensorName]) > 0
        ) {
          dataSource = "Sensor";
          dataSourceName = "S";
        } else if (this[humidityPlcName] && this[humidityPlcName] !== null && Number(this[humidityPlcName]) && Number(this[humidityPlcName]) > 0) {
          dataSource = "Plc";
          dataSourceName = "P";
        } else {
          dataSource = "Wincc";
          dataSourceName = "W";
        }

        this[humidityDataName] = this[humidityDataName.replace("humidity", "humidity" + dataSource)];
        this[humidityDataName.replace("humidity", "temperature")] = this[humidityDataName.replace("humidity", "temperature" + dataSource)];
        this[humidityDataName.replace("humidity", "pressure")] = this[humidityDataName.replace("humidity", "pressure" + dataSource)];
        this[humidityDataName.replace("humidity", "humidityAllowedMax")] =
          this[humidityDataName.replace("humidity", "humidityAllowedMax" + dataSource)];
        this[humidityDataName.replace("humidity", "humidityTooltipError")] =
          this[humidityDataName.replace("humidity", "humidityTooltipError" + dataSource)];
        this[humidityDataName.replace("humidity", "error")] = this[humidityDataName.replace("humidity", "error" + dataSource)];
        this[humidityDataName.replace("humidity", "dataSource")] = dataSourceName;

        
        this[humidityDataName.replace("humidity", "running")] = this[humidityDataName.replace("humidity", "running" + dataSource)];
        this[humidityDataName.replace("humidity", "runningClass")] = this[humidityDataName.replace("humidity", "runningClass" + dataSource)];
        this[humidityDataName.replace("humidity", "malfunction")] = this[humidityDataName.replace("humidity", "malfunction" + dataSource)];
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: bold;
        font-size: 32px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1405px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 25px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
        .sensor-source {
          margin-left: -35px;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: -32px;
        top: 0px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1400px;
        height: 250px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/jinshajiang/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .station-block-left {
          top: 122px;
          left: 173px;
        }

        .station-block-middle {
          top: 122px;
          left: 582px;
        }

        .station-block-right {
          top: 122px;
          left: 990px;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }
            &.bottom-right-pos:before {
              left: 83%;
              top: 95%;
              transform: translate(0%, 0%);
            }
            &.bottom-left-pos:before {
              left: 17%;
              top: 95%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 45%;
              top: 90%;
              transform: translate(0%, 0%);
            }
            &.top-pos:before {
              left: 46.5%;
              top: -5%;
              transform: translate(0%, 0%);
            }
            &.top-right-pos:before {
              left: 66.5%;
              top: -5%;
              transform: translate(0%, 0%);
            }
            &.top-right-pos-2:before {
              left: 81.5%;
              top: -5%;
              transform: translate(0%, 0%);
            }
            &.top-left-pos:before {
              left: 20%;
              top: -5%;
              transform: translate(0%, 0%);
            }
            &.top-left-pos-2:before {
              left: 13.5%;
              top: -5%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sta-left {
          top: 130px;
          left: 173px;
          &::before {
            bottom: 30px;
            left: -35px;
            width: 80px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 69px;
            left: -16px;
          }
          .state-info {
            right: 16px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-left-tower {
          top: 130px;
          left: 173px;
          &::before {
            bottom: 30px;
            left: -22px;
            width: 80px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 69px;
            left: 24px;
          }
          .state-info {
            right: -149px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-middle {
          top: 130px;
          left: 582px;
          &::before {
            bottom: 30px;
            left: -35px;
            width: 80px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 69px;
            left: -16px;
          }
          .state-info {
            right: 16px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-middle-tower {
          top: 130px;
          left: 582px;
          &::before {
            bottom: 30px;
            left: -22px;
            width: 80px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 69px;
            left: 24px;
          }
          .state-info {
            right: -149px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-right {
          top: 130px;
          left: 990px;
          &::before {
            bottom: 30px;
            left: -35px;
            width: 80px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 69px;
            left: -16px;
          }
          .state-info {
            right: 16px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .sta-right-tower {
          top: 130px;
          left: 990px;
          &::before {
            bottom: 30px;
            left: -22px;
            width: 80px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 69px;
            left: 24px;
          }
          .state-info {
            right: -149px;
            top: -69px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .station-block-anchor-left {
          top: 143px;
          left: 218px;
        }

        .station-block-anchor-right {
          top: 143px;
          left: 1197px;
        }

        .station-block-saddle-left {
          top: 65px;
          left: 380px;
        }

        .station-block-saddle-right {
          top: 65px;
          left: 968px;
        }

        .anchor-left {
          top: 153px;
          left: 218px;
          &::before {
            top: 43px;
            left: -50px;
            width: 90px;
            transform: rotate(-69deg);
          }
          &::after {
            top: 84px;
            left: -36px;
          }
          .state-info {
            right: 30px;
            top: 85px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .anchor-right {
          top: 153px;
          left: 1227px;
          &::before {
            top: 41px;
            left: -52px;
            width: 90px;
            transform: rotate(74deg);
          }
          &::after {
            top: 84px;
            left: 6px;
          }
          .state-info {
            right: -140px;
            top: 85px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .saddle-left {
          top: 80px;
          left: 380px;

          &::before {
            top: -30px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }

          &::after {
            top: -67px;
            left: -28px;
            width: 0px;
          }

          .state-info {
            right: -30px;
            top: -85px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .saddle-right {
          top: 80px;
          left: 969px;

          &::before {
            top: -30px;
            left: -19px;
            width: 60px;
            transform: rotate(90deg);
          }

          &::after {
            top: -67px;
            left: -28px;
            width: 0px;
          }

          .state-info {
            right: -107px;
            top: -85px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex1 {
          top: 152px;
          left: 200px;
          &::before {
            top: -34px;
            left: -33px;
            width: 70px;
            transform: rotate(79deg);
          }
          &::after {
            top: -68px;
            left: -19px;
          }
          .state-info {
            right: 37px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex2 {
          top: 120px;
          left: 285px;
          &::before {
            top: 50px;
            left: -32px;
            width: 80px;
            transform: rotate(270deg);
          }

          &::after {
            top: 138px;
            left: -5px;
            width: 0px;
          }

          .state-info {
            right: -26px;
            top: 120px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex3 {
          top: 81px;
          left: 370px;

          &::before {
            top: -6px;
            left: -10px;
            width: 30px;
            transform: rotate(79deg);
          }

          &::after {
            top: -20px;
            left: -13px;
          }

          .state-info {
            right: 28px;
            top: -18px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex4 {
          top: 81px;
          left: 399px;
          &::before {
            bottom: 48px;
            left: -20px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -130px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex5 {
          top: 100px;
          left: 455px;
          &::before {
            top: 60px;
            left: -42px;
            width: 100px;
            transform: rotate(270deg);
          }

          &::after {
            top: 138px;
            left: -32px;
            width: 20px;
            width: 0px;
          }

          .state-info {
            right: -26px;
            top: 140px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex6 {
          top: 120px;
          left: 524px;
          &::before {
            bottom: 48px;
            left: -20px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            bottom: 82px;
            left: 22px;
          }

          .state-info {
            right: -130px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex7 {
          top: 134px;
          left: 604px;
          &::before {
            top: 42px;
            left: -22px;
            width: 60px;
            transform: rotate(270deg);
          }

          &::after {
            top: 111px;
            left: -26px;
            width: 0px;
          }

          .state-info {
            right: -10px;
            top: 106px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex8 {
          top: 140px;
          left: 686px;
          &::before {
            top: 20px;
            left: -6px;
            width: 28px;
            transform: rotate(270deg);
          }

          &::after {
            display: none;
            left: 21px;
          }

          .state-info {
            left: 7px;
            top: 35px;
            transform: translateX(-49%);
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex9 {
          top: 130px;
          left: 769px;
          &::before {
            top: 45px;
            left: -22px;
            width: 60px;
            transform: rotate(270deg);
          }

          &::after {
            top: 120px;
            left: -26px;
            width: 0px;
          }

          .state-info {
            right: -82px;
            top: 110px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex10 {
          top: 121px;
          left: 835px;
          &::before {
            bottom: 48px;
            right: -18px;
            width: 70px;
            transform: rotate(79deg);
          }

          &::after {
            top: -68px;
            left: -22px;
          }

          .state-info {
            right: 35px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex11 {
          top: 100px;
          left: 910px;
          &::before {
            top: 60px;
            left: -42px;
            width: 100px;
            transform: rotate(270deg);
          }

          &::after {
            top: 138px;
            left: -32px;
            width: 20px;
            width: 0px;
          }

          .state-info {
            right: -75px;
            top: 140px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
        .ex12 {
          top: 81px;
          left: 958px;

          &::before {
            top: -33px;
            left: -38px;
            width: 70px;
            transform: rotate(71deg);
          }

          &::after {
            top: -67px;
            left: -28px;
          }

          .state-info {
            right: 41px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex13 {
          top: 81px;
          left: 988px;
          &::before {
            top: -8px;
            left: -5px;
            width: 30px;
            transform: rotate(101deg);
          }

          &::after {
            top: -22px;
            left: 13px;
          }

          .state-info {
            right: -122px;
            top: -20px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex14 {
          top: 118px;
          left: 1090px;
          &::before {
            top: 50px;
            left: -32px;
            width: 80px;
            transform: rotate(270deg);
          }

          &::after {
            top: 138px;
            left: -5px;
            width: 0px;
          }

          .state-info {
            right: -75px;
            top: 120px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }

        .ex15 {
          top: 155px;
          left: 1220px;
          &::before {
            top: -34px;
            right: -35px;
            width: 70px;
            transform: rotate(-79deg);
          }

          &::after {
            top: -68px;
            right: -21px;
          }

          .state-info {
            left: 39px;
            top: -66px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 110px;
          }
        }
      }
    }
  }
}
</style>
